var _Es, _pn, _we, _Vi, _de;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var cs = Object.defineProperty;
var us = function us(t, e, n) {
  return e in t ? cs(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : t[e] = n;
};
var _ = function _(t, e, n) {
  return us(t, _typeof(e) != "symbol" ? e + "" : e, n);
};
import ds from "qs";
var be;
var gs = new Uint8Array(16);
function hs() {
  if (!be && (be = (typeof crypto === "undefined" ? "undefined" : _typeof(crypto)) < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !be)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return be(gs);
}
var D = [];
for (var t = 0; t < 256; ++t) D.push((t + 256).toString(16).slice(1));
function fs(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return D[t[e + 0]] + D[t[e + 1]] + D[t[e + 2]] + D[t[e + 3]] + "-" + D[t[e + 4]] + D[t[e + 5]] + "-" + D[t[e + 6]] + D[t[e + 7]] + "-" + D[t[e + 8]] + D[t[e + 9]] + "-" + D[t[e + 10]] + D[t[e + 11]] + D[t[e + 12]] + D[t[e + 13]] + D[t[e + 14]] + D[t[e + 15]];
}
var ps = (typeof crypto === "undefined" ? "undefined" : _typeof(crypto)) < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto),
  At = {
    randomUUID: ps
  };
function vs(t, e, n) {
  if (At.randomUUID && !e && !t) return At.randomUUID();
  t = t || {};
  var s = t.random || (t.rng || hs)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, e) {
    n = n || 0;
    for (var r = 0; r < 16; ++r) e[n + r] = s[r];
    return e;
  }
  return fs(s);
}
var gn = /* @__PURE__ */function (t) {
  return t.DEVELOPMENT = "development", t.PRODUCTION = "production", t.SANDBOX = "sandbox", t.STAGING = "staging", t;
}(gn || {});
var X = gn;
var hn = /* @__PURE__ */function (t) {
  return t.SANDBOX = "https://tracking.dev1.sandbox-ezcater.com", t.STAGING = "https://tracking.staging-ezcater.com", t.PRODUCTION = "https://tracking.ezcater.com", t;
}(hn || {});
var Te = hn,
  Es = (_Es = {}, _defineProperty(_Es, X.DEVELOPMENT, "localhost"), _defineProperty(_Es, X.SANDBOX, "sandbox-ezcater.com"), _defineProperty(_Es, X.STAGING, "staging-ezcater.com"), _Es),
  fn = function fn(t) {
    return Object.keys(X).map(function (s) {
      return X[s];
    }).filter(function (s) {
      var a;
      var r = Es[s],
        i = (a = t == null ? void 0 : t.location) == null ? void 0 : a.origin;
      return r && i ? i.indexOf(r) !== -1 : null;
    })[0] || X.PRODUCTION;
  },
  pn = (_pn = {}, _defineProperty(_pn, X.DEVELOPMENT, Te.STAGING), _defineProperty(_pn, X.STAGING, Te.STAGING), _defineProperty(_pn, X.SANDBOX, Te.SANDBOX), _defineProperty(_pn, X.PRODUCTION, Te.PRODUCTION), _pn),
  ms = function ms(t) {
    var e = t || fn((typeof window === "undefined" ? "undefined" : _typeof(window)) > "u" ? void 0 : window);
    return "".concat(pn[e], "/graphql");
  },
  ys = function ys(t) {
    var e = t || fn((typeof window === "undefined" ? "undefined" : _typeof(window)) > "u" ? void 0 : window);
    return "".concat(pn[e], "/tid");
  },
  Ss = 365,
  Ot = "tid",
  Pt = {
    get: function get() {
      var t = "".concat(Ot, "="),
        e = (typeof document === "undefined" ? "undefined" : _typeof(document)) > "u" ? [] : document.cookie.split(";");
      for (var n = 0; n < e.length; n++) {
        var s = e[n];
        for (; s.charAt(0) === " ";) s = s.substring(1);
        if (s.indexOf(t) === 0) return s.substring(t.length, s.length);
      }
      return "";
    },
    set: function set(t) {
      return fetch(ys(t), {
        credentials: "include"
      }).then(function (e) {
        return e.json();
      }).then(function (e) {
        var n = /* @__PURE__ */new Date();
        n.setTime(n.getTime() + 24 * 60 * 60 * 1e3 * Ss);
        var s = "".concat(Ot, "=").concat(e.tid),
          r = "expires=".concat(n.toUTCString()),
          i = "path=/";
        return (typeof document === "undefined" ? "undefined" : _typeof(document)) < "u" && (document.cookie = "".concat(s, ";").concat(r, ";").concat(i)), e.tid;
      });
    }
  },
  _s = /* GraphQL */"\n  mutation trackEvent($trackingId: String!, $appName: String!, $rawEvent: String!) {\n    trackEvent(tracking_id: $trackingId, appName: $appName, rawEvent: $rawEvent) {\n      success\n    }\n  }\n",
  Is = function Is(_ref) {
    var t = _ref.apiUrl,
      e = _ref.eventName,
      n = _ref.namespace,
      s = _ref.properties,
      r = _ref.trackingId;
    var i = {
      query: _s,
      variables: {
        appName: n,
        rawEvent: JSON.stringify(_objectSpread({
          category: n,
          event: e
        }, s)),
        trackingId: r
      }
    };
    return {
      url: t,
      data: i
    };
  },
  bs = Is,
  Ts = function Ts(_ref2) {
    var t = _ref2.url,
      e = _ref2.data;
    return fetch(t, {
      body: JSON.stringify(e),
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (n) {
      return n.json();
    }).then(function (n) {
      return n.data.trackEvent.success;
    });
  },
  Rs = function Rs(_ref3) {
    var t = _ref3.url,
      e = _ref3.data;
    var n = navigator.sendBeacon.bind(navigator),
      s = new Blob([ds.stringify(e)], {
        // This content type is necessary for `sendBeacon`:
        type: "application/x-www-form-urlencoded"
      });
    return Promise.resolve().then(function () {
      try {
        return n(t, s);
      } catch (r) {
        return console.error("Encounted error %o when sending tracking request, payload size: %o", r, s.size), !1;
      }
    });
  },
  Nt = function Nt(t, _ref4) {
    var e = _ref4.ssr;
    return !!(!e && (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) < "u" && navigator.sendBeacon) ? Rs(t) : Ts(t);
  },
  As = function As(t) {
    return typeof t == "boolean";
  },
  Os = As,
  Ps = function Ps(t) {
    return t === null;
  },
  Ns = Ps,
  ws = function ws(t) {
    return typeof t == "number";
  },
  Ds = ws,
  ks = function ks(t) {
    return typeof t == "string";
  },
  Ls = ks,
  pt = {
    boolean: Os,
    null: Ns,
    number: Ds,
    string: Ls
  },
  Cs = function Cs(t, e) {
    return t.some(function (n) {
      var s = pt[n];
      return s(e);
    });
  },
  Us = function Us(_ref5) {
    var t = _ref5.eventName,
      e = _ref5.eventDictionary,
      _ref5$properties = _ref5.properties,
      n = _ref5$properties === void 0 ? {} : _ref5$properties;
    var s = e.events[t];
    if (!s) throw new Error("No definition found for event ".concat(t, " in event dictionary."));
    var r = Object.keys(n),
      i = Object.keys(s.properties || {});
    !s.properties && !r.length || (r.forEach(function (a) {
      if (!i.some(function (c) {
        return c === a;
      })) throw new Error("No definition found for property ".concat(a, " on event ").concat(t, " in event dictionary."));
    }), i.forEach(function (a) {
      var m;
      var l = a,
        c = n[l],
        d = (m = s.properties[l]) == null ? void 0 : m.type;
      if (c === void 0) {
        var N = s.properties[l];
        throw new Error("Invalid value \"".concat(c, "\" for property \"").concat(a, "\", must be of type \"").concat(N == null ? void 0 : N.type, "\""));
      }
      if (Array.isArray(d)) {
        if (!Cs(d, c)) throw new Error("Invalid type for property ".concat(a, ", must be one of types: ").concat(d.join(", ")));
        return;
      }
      var p = pt[d];
      if (!p(c)) throw new Error("Invalid type for property ".concat(a, ", must be of type ").concat(d));
    }));
  },
  Ms = ["account_source", "account_type", "action", "advocate_email", "api_version", "app_name", "app_version", "begin_on", "brand_id", "browser_height", "browser_width", "call_sid", "call_sid_source", "call_status", "category", "caterer_count", "caterer_id", "caterer_uuid", "client", "close_order_ids", "closest_order_id", "controller", "created_at", "delivery_id", "device_name", "device_os_version", "digits", "direction", "driver_id", "email", "email_body", "email_subject", "event", "event_name", "event_source", "experiment_result", "experiment_test", "expire_on", "filter_name", "filter_value", "focus", "from", "from_city", "from_country", "from_state", "from_zip", "address_string", "group_tracking_id", "id", "instance", "invite_first_name", "invite_last_name", "invite_name", "ip_address", "key", "landing_url", "language", "lead_channel", "lead_upload_id", "loadtime", "location_enabled_status", "menu_item_id", "method", "minutes_to_event", "misc_json", "name_override", "order_id", "order_source", "origin", "original_user_agent", "other_tracking_id", "page", "page_interactive", "params_action", "params_controller", "pipeline_version", "pixel_ratio", "platform_name", "pmt_id", "pmt_type", "private_store", "project", "promo_code", "promo_name", "question_response", "rate_change", "record_created_at", "referral_code", "referral_date", "referred_email", "referrer_url", "reg_source", "result", "revenue", "rid", "screen_size", "search_id", "search_keyword", "search_result_count", "server_response", "sort_user_type", "sort_weights", "source", "staples_partnership", "state", "status", "street", "sub_category", "subscription_locked", "subscription_plan_rate", "subscription_reason", "to", "tracking_id", "type", "ui_element_name", "unique_record_id", "url", "user_agent", "user_created_at", "user_properties", "user_type", "utm_adgroup_name", "utm_spid", "value", "variant"],
  $s = function $s(t, _ref6) {
    var e = _ref6.validateAllowlist;
    if (!t.events) throw new Error("Event dictionary must include valid event definitions.");
    Object.keys(t.events).forEach(function (n) {
      var s = t.events[n];
      s.properties && Object.keys(s.properties).forEach(function (r) {
        var i = r,
          a = s.properties[i],
          l = Object.keys(pt);
        if (e && Ms.indexOf(i) === -1) throw new Error("Property \"".concat(r, "\" is not included in the event allowlist. For more information see: https://engportal.ezcater.net/docs/default/Component/tracker-js/event_dictionaries/"));
        if (!(a != null && a.type)) throw new Error("Property \"".concat(r, "\" for event \"").concat(n, "\" must have a type property."));
        var c = Array.isArray(a.type),
          d = a.type.length === 0;
        if (c && d) throw new Error("Types array for \"".concat(r, "\" for event \"").concat(r, "\" must contain one or more of the following types: ").concat(l.join(", "), "."));
        if (c) {
          a.type.forEach(function (m) {
            if (l.indexOf(m) === -1) throw new Error("Type array for \"".concat(r, "\" on event \"").concat(n, "\" must contain types with one or more of the following: ").concat(l.join(", "), "."));
          });
          return;
        }
        if (l.indexOf(a.type) === -1) throw new Error("Type for \"".concat(r, "\" for event \"").concat(n, "\" must have a type with one or more of the following: ").concat(l.join(", "), "."));
      });
    });
  };
function O(t) {
  return t != null && _typeof(t) == "object" && t["@@functional/placeholder"] === !0;
}
function q(t) {
  return function e(n) {
    return arguments.length === 0 || O(n) ? e : t.apply(this, arguments);
  };
}
function z(t) {
  return function e(n, s) {
    switch (arguments.length) {
      case 0:
        return e;
      case 1:
        return O(n) ? e : q(function (r) {
          return t(n, r);
        });
      default:
        return O(n) && O(s) ? e : O(n) ? q(function (r) {
          return t(r, s);
        }) : O(s) ? q(function (r) {
          return t(n, r);
        }) : t(n, s);
    }
  };
}
function vt(t) {
  return function e(n, s, r) {
    switch (arguments.length) {
      case 0:
        return e;
      case 1:
        return O(n) ? e : z(function (i, a) {
          return t(n, i, a);
        });
      case 2:
        return O(n) && O(s) ? e : O(n) ? z(function (i, a) {
          return t(i, s, a);
        }) : O(s) ? z(function (i, a) {
          return t(n, i, a);
        }) : q(function (i) {
          return t(n, s, i);
        });
      default:
        return O(n) && O(s) && O(r) ? e : O(n) && O(s) ? z(function (i, a) {
          return t(i, a, r);
        }) : O(n) && O(r) ? z(function (i, a) {
          return t(i, s, a);
        }) : O(s) && O(r) ? z(function (i, a) {
          return t(n, i, a);
        }) : O(n) ? q(function (i) {
          return t(i, s, r);
        }) : O(s) ? q(function (i) {
          return t(n, i, r);
        }) : O(r) ? q(function (i) {
          return t(n, s, i);
        }) : t(n, s, r);
    }
  };
}
function Re(t, e) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var Bs = /* @__PURE__ */q(function (e) {
  return e === null ? "Null" : e === void 0 ? "Undefined" : Object.prototype.toString.call(e).slice(8, -1);
});
function wt(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
var Gs = Number.isInteger || function (e) {
  return e << 0 === e;
};
function xs(t) {
  return Object.prototype.toString.call(t) === "[object String]";
}
var Fs = /* @__PURE__ */z(function (e, n) {
  var s = e < 0 ? n.length + e : e;
  return xs(n) ? n.charAt(s) : n[s];
});
function Hs(t) {
  return new RegExp(t.source, t.flags ? t.flags : (t.global ? "g" : "") + (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.sticky ? "y" : "") + (t.unicode ? "u" : "") + (t.dotAll ? "s" : ""));
}
function vn(t, e, n) {
  if (n || (n = new Vs()), js(t)) return t;
  var s = function s(i) {
    var a = n.get(t);
    if (a) return a;
    n.set(t, i);
    for (var l in t) Object.prototype.hasOwnProperty.call(t, l) && (i[l] = e ? vn(t[l], !0, n) : t[l]);
    return i;
  };
  switch (Bs(t)) {
    case "Object":
      return s(Object.create(Object.getPrototypeOf(t)));
    case "Array":
      return s([]);
    case "Date":
      return new Date(t.valueOf());
    case "RegExp":
      return Hs(t);
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "BigInt64Array":
    case "BigUint64Array":
      return t.slice();
    default:
      return t;
  }
}
function js(t) {
  var e = _typeof(t);
  return t == null || e != "object" && e != "function";
}
var Vs = /* @__PURE__ */function () {
    function t() {
      this.map = {}, this.length = 0;
    }
    return t.prototype.set = function (e, n) {
      var s = this.hash(e);
      var r = this.map[s];
      r || (this.map[s] = r = []), r.push([e, n]), this.length += 1;
    }, t.prototype.hash = function (e) {
      var n = [];
      for (var s in e) n.push(Object.prototype.toString.call(e[s]));
      return n.join();
    }, t.prototype.get = function (e) {
      if (this.length <= 180) {
        for (var r in this.map) {
          var i = this.map[r];
          for (var a = 0; a < i.length; a += 1) {
            var l = i[a];
            if (l[0] === e) return l[1];
          }
        }
        return;
      }
      var n = this.hash(e),
        s = this.map[n];
      if (s) for (var _r2 = 0; _r2 < s.length; _r2 += 1) {
        var _i2 = s[_r2];
        if (_i2[0] === e) return _i2[1];
      }
    }, t;
  }(),
  I = /* @__PURE__ */q(function (e) {
    return e != null && typeof e.clone == "function" ? e.clone() : vn(e, !0);
  }),
  Qs = /* @__PURE__ */z(function (e, n) {
    return e.map(function (s) {
      for (var r = n, i = 0, a; i < s.length;) {
        if (r == null) return;
        a = s[i], r = Gs(a) ? Fs(a, r) : r[a], i += 1;
      }
      return r;
    });
  }),
  Ks = /* @__PURE__ */z(function (e, n) {
    return Qs([e], n)[0];
  }),
  zs = /* @__PURE__ */vt(function (e, n, s) {
    var r = {},
      i;
    n = n || {}, s = s || {};
    for (i in n) Re(i, n) && (r[i] = Re(i, s) ? e(i, n[i], s[i]) : n[i]);
    for (i in s) Re(i, s) && !Re(i, r) && (r[i] = s[i]);
    return r;
  }),
  Ys = /* @__PURE__ */vt(function t(e, n, s) {
    return zs(function (r, i, a) {
      return wt(i) && wt(a) ? t(e, i, a) : e(r, i, a);
    }, n, s);
  }),
  Xs = /* @__PURE__ */vt(function (e, n, s) {
    return Ys(function (r, i, a) {
      return e(i, a);
    }, n, s);
  }),
  En = /* @__PURE__ */z(function (e, n) {
    var s = {};
    for (var r in n) e(n[r], r, n) && (s[r] = n[r]);
    return s;
  });
var f = function f(t) {
    return typeof t == "function" && !!(t.constructor && t.call && t.apply);
  },
  k = function k(t) {
    return typeof t == "string";
  },
  H = function H(t) {
    return t === null;
  },
  L = function L(t) {
    return _typeof(t) > "u";
  },
  V = function V(t) {
    return H(t) || L(t);
  },
  A = function A(t) {
    return !L(t);
  },
  Ge = function Ge(t) {
    return !V(t);
  },
  qs = function qs(t) {
    return Ge(t) && t !== "";
  },
  mn = function mn(t) {
    return t instanceof Error;
  },
  nt = function nt(t, e) {
    var n = e.split(".");
    return Ks(n, t);
  },
  Ws = function Ws(t, e) {
    return !!nt(t, e);
  },
  yn = function yn(t) {
    return !H(t) && _typeof(t) == "object" && !Array.isArray(t);
  },
  y = function y(t) {
    return !H(t) && Object.prototype.toString.call(t) === "[object Object]";
  },
  Js = function Js(t, e) {
    if (!Array.isArray(t) || !Array.isArray(e)) return I(e);
    var n = I(t);
    return e.forEach(function (s, r) {
      n[r] = Array.isArray(s) || yn(s) ?
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      w(n[r], s) : s;
    }), n;
  },
  w = function w(t, e) {
    return Xs(Js, t, e);
  },
  xe = function xe(t) {
    return y(t) && Object.keys(t).length > 0;
  },
  ve = function ve(t) {
    var e = En(A, t);
    return Object.keys(e).forEach(function (n) {
      var s = e[n];
      y(s) && (e[n] = ve(s));
    }), e;
  },
  ne = function ne(t) {
    var e = En(Ge, t);
    return Object.keys(e).forEach(function (n) {
      var s = e[n];
      y(s) && (e[n] = ne(s));
    }), e;
  },
  Zs = function Zs(t) {
    return t.replace(/^\s+|\s+$/gm, "");
  },
  er = function er(t) {
    return t.replace(/ {2,}/g, " ");
  },
  Ce = function Ce(t) {
    var e = t;
    if (!k(t) && !V(t)) try {
      e = JSON.stringify(t);
    } catch (_unused) {
      e = null;
    }
    return e;
  },
  tr = function tr(t) {
    var e = Array.from(t, function (n) {
      return String.fromCodePoint(n);
    }).join("");
    return globalThis.btoa(e);
  },
  nr = function nr(t) {
    return tr(new TextEncoder().encode(t));
  },
  Ue = function Ue(t, e, n, s, r) {
    var i = {
      category: t,
      name: e,
      properties: n,
      options: s
    };
    return f(r) && (i.callback = r), f(s) && (i.category = t, i.name = e, i.properties = n, delete i.options, i.callback = s), f(n) && (i.category = t, i.name = e, delete i.properties, delete i.options, i.callback = n), f(e) && (i.category = t, delete i.name, delete i.properties, delete i.options, i.callback = e), f(t) && (delete i.category, delete i.name, delete i.properties, delete i.options, i.callback = t), y(t) ? (delete i.name, delete i.category, i.properties = t, i.options = e) : y(e) && (delete i.name, i.properties = e, i.options = f(n) ? null : n), k(t) && !k(e) && (delete i.category, i.name = t), A(i.category) || delete i.category, A(i.name) || delete i.name, i.properties = i.properties ? I(i.properties) : {}, A(i.options) ? i.options = I(i.options) : delete i.options, i.properties = w(y(i.properties) ? i.properties : {}, {
      name: k(i.name) ? i.name : null,
      category: k(i.category) ? i.category : null
    }), i;
  },
  Et = function Et(t, e, n, s) {
    var r = {
      name: t,
      properties: e,
      options: n
    };
    return f(s) && (r.callback = s), f(n) && (r.properties = e, delete r.options, r.callback = n), f(e) && (delete r.properties, delete r.options, r.callback = e), r.properties = Ge(r.properties) ? I(r.properties) : {}, A(r.options) ? r.options = I(r.options) : delete r.options, r;
  },
  Sn = function Sn(t, e, n, s) {
    var r = {
      userId: t,
      traits: e,
      options: n
    };
    return f(s) && (r.callback = s), f(n) && (r.userId = t, r.traits = e, delete r.options, r.callback = n), f(e) && (r.userId = t, delete r.traits, delete r.options, r.callback = e), (y(t) || H(t)) && (r.userId = null, r.traits = t, r.options = e), A(r.userId) ? r.userId = Ce(r.userId) : delete r.userId, y(r.traits) ? r.traits = I(r.traits) : delete r.traits, A(r.options) ? r.options = I(r.options) : delete r.options, r;
  },
  _n = function _n(t, e, n, s) {
    var r = {
      to: t,
      from: e,
      options: n
    };
    return f(s) && (r.callback = s), f(n) && (r.to = t, r.from = e, delete r.options, r.callback = n), f(e) ? (r.to = t, delete r.from, delete r.options, r.callback = e) : (y(e) || H(e)) && (r.to = t, delete r.from, r.options = e), f(t) ? (delete r.to, delete r.from, delete r.options, r.callback = t) : (y(t) || H(t)) && (delete r.to, delete r.from, r.options = t), A(r.to) ? r.to = Ce(r.to) : delete r.to, A(r.from) ? r.from = Ce(r.from) : delete r.from, A(r.options) ? r.options = I(r.options) : delete r.options, r;
  },
  In = function In(t, e, n, s) {
    var r = {
      groupId: t,
      traits: e,
      options: n
    };
    return f(s) && (r.callback = s), f(n) && (r.groupId = t, r.traits = e, delete r.options, r.callback = n), f(e) && (r.groupId = t, delete r.traits, delete r.options, r.callback = e), f(t) ? (r.groupId = null, delete r.traits, delete r.options, r.callback = t) : (y(t) || H(t)) && (r.groupId = null, r.traits = t, r.options = f(e) ? null : e), A(r.groupId) ? r.groupId = Ce(r.groupId) : delete r.groupId, r.traits = y(r.traits) ? I(r.traits) : {}, A(r.options) ? r.options = I(r.options) : delete r.options, r;
  },
  bn = "CapabilitiesManager",
  j = "ConfigManager",
  mt = "EventManager",
  Dt = "PluginsManager",
  Ee = "UserSessionManager",
  Ae = "ErrorHandler",
  le = "PluginEngine",
  kt = "StoreManager",
  sr = "readyApi",
  rr = "EventRepository",
  ir = "ExternalSrcLoader",
  or = "HttpClient",
  Lt = "RudderStackApplication",
  Ye = "AnalyticsCore",
  Ct = "RudderLabs JavaScript SDK",
  Me = "3.1.1",
  ar = "com.rudderlabs.javascript",
  lr = "npm",
  Ut = "RudderJS-Initiated",
  cr = "ad-block page request",
  ur = "/ad-blocked",
  st = "preloadedEventsBuffer",
  dr = "Consent Management Interaction",
  gr = "ajs_trait_",
  hr = "ajs_prop_",
  Mt = "ajs_aid",
  $t = "ajs_uid",
  Bt = "ajs_event",
  fr = 10 * 1e3,
  pr = 31536e3 * 1e3,
  Se = 30 * 60 * 1e3,
  Gt = 10 * 1e3,
  vr = 10 * 1e3,
  Er = 250,
  Tn = function Tn() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "app";
    globalThis.RudderStackGlobals || (globalThis.RudderStackGlobals = {}), globalThis.RudderStackGlobals[t] || (globalThis.RudderStackGlobals[t] = {});
  },
  Fe = function Fe(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "app";
    Tn(n), globalThis.RudderStackGlobals[n][t] = e;
  },
  mr = function mr(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "app";
    return Tn(e), globalThis.RudderStackGlobals[e][t];
  };
function yr(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Er;
  var s;
  return function () {
    for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
      r[_key] = arguments[_key];
    }
    globalThis.clearTimeout(s), s = globalThis.setTimeout(function () {
      t.apply(e, r);
    }, n);
  };
}
var xt = function xt(t, e) {
    var n = {};
    return t.forEach(function (s, r) {
      if (r.startsWith(e)) {
        var i = r.substring(e.length);
        n[i] = t.get(r);
      }
    }), n;
  },
  Sr = function Sr() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var e = {
        trait: gr,
        properties: hr
      },
      n = new URLSearchParams(globalThis.location.search);
    n.get(Bt) && t.unshift(["track", n.get(Bt), xt(n, e.properties)]), n.get($t) && t.unshift(["identify", n.get($t), xt(n, e.trait)]), n.get(Mt) && t.unshift(["setAnonymousId", n.get(Mt)]);
  },
  _r = function _r(t) {
    var e = "load";
    var n = [],
      s = 0;
    for (; s < t.length;) {
      if (t[s] && t[s][0] === e) {
        n = I(t[s]), t.splice(s, 1);
        break;
      }
      s += 1;
    }
    return n;
  },
  Ir = function Ir(t) {
    var e = "consent",
      n = t.filter(function (r) {
        return r[0] === e;
      }),
      s = t.filter(function (r) {
        return r[0] !== e;
      });
    t.splice.apply(t, [0, t.length].concat(_toConsumableArray(n), _toConsumableArray(s)));
  },
  br = function br(t) {
    var e = mr(st) || [];
    Sr(e), e.length > 0 && (t.enqueuePreloadBufferEvents(e), Fe(st, []));
  },
  Tr = function Tr(t, e) {
    var n = t.shift();
    var s;
    if (f(e[n])) {
      switch (n) {
        case "page":
          s = Ue.apply(void 0, _toConsumableArray(t));
          break;
        case "track":
          s = Et.apply(void 0, _toConsumableArray(t));
          break;
        case "identify":
          s = Sn.apply(void 0, _toConsumableArray(t));
          break;
        case "alias":
          s = _n.apply(void 0, _toConsumableArray(t));
          break;
        case "group":
          s = In.apply(void 0, _toConsumableArray(t));
          break;
        default:
          e[n].apply(e, _toConsumableArray(t));
          break;
      }
      s && e[n](s);
    }
  },
  Rr = 10 * 1e3,
  S = ":: ",
  Ar = function Ar(t) {
    return "A script with the id \"".concat(t, "\" is already loaded. Skipping the loading of this script to prevent conflicts.");
  },
  Ft = function Ft(t, e) {
    return "Failed to load the script with the id \"".concat(t, "\" from URL \"").concat(e, "\".");
  },
  Or = function Or(t, e, n) {
    return "A timeout of ".concat(n, " ms occurred while trying to load the script with id \"").concat(t, "\" from URL \"").concat(e, "\".");
  },
  Pr = function Pr(t, e) {
    return "".concat(t).concat(S, "A circular reference has been detected in the object and the property \"").concat(e, "\" has been dropped from the output.");
  },
  Nr = "Failed to convert the value to a JSON string.",
  wr = "JSONStringify",
  Dr = function Dr(t, e, n) {
    var s = [];
    return function (r, i) {
      if (!(e != null && e.includes(r)) && !(t && V(i))) {
        if (_typeof(i) != "object" || H(i)) return i;
        for (; s.length > 0 && s[s.length - 1] !== this;) s.pop();
        return s.includes(i) ? (n == null || n.warn(Pr(wr, r)), "[Circular Reference]") : (s.push(i), i);
      }
    };
  },
  He = function He(t, e, n, s) {
    try {
      return JSON.stringify(t, Dr(e, n, s));
    } catch (r) {
      return s == null || s.warn(Nr, r), null;
    }
  },
  _e = function _e(t, e) {
    var n = t;
    return mn(t) ? n.message = "".concat(e, ": ").concat(t.message) : n = new Error("".concat(e, ": ").concat(He(t))), n;
  },
  kr = "RS_JS_SDK",
  Lr = function Lr(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var a = document.createElement("script");
    return a.type = "text/javascript", a.onload = s, a.onerror = r, a.src = t, a.id = e, a.async = n, a.setAttribute("data-append-origin", kr), Object.keys(i).forEach(function (l) {
      a.setAttribute(l, i[l]);
    }), a;
  },
  Cr = function Cr(t) {
    var i, a, l, c;
    var e = document.getElementsByTagName("head");
    if (e.length > 0) {
      (a = e[0]) == null || a.insertBefore(t, (i = e[0]) == null ? void 0 : i.firstChild);
      return;
    }
    var n = document.getElementsByTagName("script");
    if (n.length > 0 && (l = n[0]) != null && l.parentNode) {
      (c = n[0]) == null || c.parentNode.insertBefore(t, n[0]);
      return;
    }
    var s = document.createElement("head");
    s.appendChild(t);
    var r = document.getElementsByTagName("html")[0];
    r == null || r.insertBefore(s, r.firstChild);
  },
  Ur = function Ur(t, e, n) {
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    var r = arguments.length > 4 ? arguments[4] : undefined;
    return new Promise(function (i, a) {
      document.getElementById(e) && a(new Error(Ar(e)));
      try {
        var c;
        Cr(Lr(t, e, s, function () {
          globalThis.clearTimeout(c), i(e);
        }, function () {
          globalThis.clearTimeout(c), a(new Error(Ft(e, t)));
        }, r)), c = globalThis.setTimeout(function () {
          a(new Error(Or(e, t, n)));
        }, n);
      } catch (c) {
        a(_e(c, Ft(e, t)));
      }
    });
  };
var Rn = /*#__PURE__*/function () {
  function Rn(e, n) {
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Rr;
    _classCallCheck(this, Rn);
    _(this, "hasErrorHandler", !1);
    this.errorHandler = e, this.logger = n, this.timeout = s, this.hasErrorHandler = !!this.errorHandler, this.onError = this.onError.bind(this);
  }
  /**
  * Load external resource of type javascript
  */
  _createClass(Rn, [{
    key: "loadJSFile",
    value: function loadJSFile(e) {
      var _this = this;
      var n = e.url,
        s = e.id,
        r = e.timeout,
        i = e.async,
        a = e.callback,
        l = e.extraAttributes,
        c = !f(a);
      Ur(n, s, r || this.timeout, i, l).then(function (d) {
        c || a(d);
      }).catch(function (d) {
        _this.onError(d), c || a();
      });
    }
    /**
    * Handle errors
    */
  }, {
    key: "onError",
    value: function onError(e) {
      var n;
      if (this.hasErrorHandler) (n = this.errorHandler) == null || n.onError(e, ir);else throw e;
    }
  }]);
  return Rn;
}();
function je() {
  throw new Error("Cycle detected");
}
var Mr = Symbol.for("preact-signals");
function Ve() {
  if (ee > 1) ee--;else {
    for (var t, e = !1; ye !== void 0;) {
      var n = ye;
      for (ye = void 0, rt++; n !== void 0;) {
        var s = n.o;
        if (n.o = void 0, n.f &= -3, !(8 & n.f) && On(n)) try {
          n.c();
        } catch (r) {
          e || (t = r, e = !0);
        }
        n = s;
      }
    }
    if (rt = 0, ee--, e) throw t;
  }
}
function M(t) {
  if (ee > 0) return t();
  ee++;
  try {
    return t();
  } finally {
    Ve();
  }
}
var P = void 0,
  ye = void 0,
  ee = 0,
  rt = 0,
  $e = 0;
function An(t) {
  if (P !== void 0) {
    var e = t.n;
    if (e === void 0 || e.t !== P) return e = {
      i: 0,
      S: t,
      p: P.s,
      n: void 0,
      t: P,
      e: void 0,
      x: void 0,
      r: e
    }, P.s !== void 0 && (P.s.n = e), P.s = e, t.n = e, 32 & P.f && t.S(e), e;
    if (e.i === -1) return e.i = 0, e.n !== void 0 && (e.n.p = e.p, e.p !== void 0 && (e.p.n = e.n), e.p = P.s, e.n = void 0, P.s.n = e, P.s = e), e;
  }
}
function $(t) {
  this.v = t, this.i = 0, this.n = void 0, this.t = void 0;
}
$.prototype.brand = Mr;
$.prototype.h = function () {
  return !0;
};
$.prototype.S = function (t) {
  this.t !== t && t.e === void 0 && (t.x = this.t, this.t !== void 0 && (this.t.e = t), this.t = t);
};
$.prototype.U = function (t) {
  if (this.t !== void 0) {
    var e = t.e,
      n = t.x;
    e !== void 0 && (e.x = n, t.e = void 0), n !== void 0 && (n.e = e, t.x = void 0), t === this.t && (this.t = n);
  }
};
$.prototype.subscribe = function (t) {
  var e = this;
  return W(function () {
    var n = e.value,
      s = 32 & this.f;
    this.f &= -33;
    try {
      t(n);
    } finally {
      this.f |= s;
    }
  });
};
$.prototype.valueOf = function () {
  return this.value;
};
$.prototype.toString = function () {
  return this.value + "";
};
$.prototype.toJSON = function () {
  return this.value;
};
$.prototype.peek = function () {
  return this.v;
};
Object.defineProperty($.prototype, "value", {
  get: function get() {
    var t = An(this);
    return t !== void 0 && (t.i = this.i), this.v;
  },
  set: function set(t) {
    if (P instanceof ae && function () {
      throw new Error("Computed cannot have side-effects");
    }(), t !== this.v) {
      rt > 100 && je(), this.v = t, this.i++, $e++, ee++;
      try {
        for (var e = this.t; e !== void 0; e = e.x) e.t.N();
      } finally {
        Ve();
      }
    }
  }
});
function u(t) {
  return new $(t);
}
function On(t) {
  for (var e = t.s; e !== void 0; e = e.n) if (e.S.i !== e.i || !e.S.h() || e.S.i !== e.i) return !0;
  return !1;
}
function Pn(t) {
  for (var e = t.s; e !== void 0; e = e.n) {
    var n = e.S.n;
    if (n !== void 0 && (e.r = n), e.S.n = e, e.i = -1, e.n === void 0) {
      t.s = e;
      break;
    }
  }
}
function Nn(t) {
  for (var e = t.s, n = void 0; e !== void 0;) {
    var s = e.p;
    e.i === -1 ? (e.S.U(e), s !== void 0 && (s.n = e.n), e.n !== void 0 && (e.n.p = s)) : n = e, e.S.n = e.r, e.r !== void 0 && (e.r = void 0), e = s;
  }
  t.s = n;
}
function ae(t) {
  $.call(this, void 0), this.x = t, this.s = void 0, this.g = $e - 1, this.f = 4;
}
(ae.prototype = new $()).h = function () {
  if (this.f &= -3, 1 & this.f) return !1;
  if ((36 & this.f) == 32 || (this.f &= -5, this.g === $e)) return !0;
  if (this.g = $e, this.f |= 1, this.i > 0 && !On(this)) return this.f &= -2, !0;
  var t = P;
  try {
    Pn(this), P = this;
    var e = this.x();
    (16 & this.f || this.v !== e || this.i === 0) && (this.v = e, this.f &= -17, this.i++);
  } catch (n) {
    this.v = n, this.f |= 16, this.i++;
  }
  return P = t, Nn(this), this.f &= -2, !0;
};
ae.prototype.S = function (t) {
  if (this.t === void 0) {
    this.f |= 36;
    for (var e = this.s; e !== void 0; e = e.n) e.S.S(e);
  }
  $.prototype.S.call(this, t);
};
ae.prototype.U = function (t) {
  if (this.t !== void 0 && ($.prototype.U.call(this, t), this.t === void 0)) {
    this.f &= -33;
    for (var e = this.s; e !== void 0; e = e.n) e.S.U(e);
  }
};
ae.prototype.N = function () {
  if (!(2 & this.f)) {
    this.f |= 6;
    for (var t = this.t; t !== void 0; t = t.x) t.t.N();
  }
};
ae.prototype.peek = function () {
  if (this.h() || je(), 16 & this.f) throw this.v;
  return this.v;
};
Object.defineProperty(ae.prototype, "value", {
  get: function get() {
    1 & this.f && je();
    var t = An(this);
    if (this.h(), t !== void 0 && (t.i = this.i), 16 & this.f) throw this.v;
    return this.v;
  }
});
function wn(t) {
  var e = t.u;
  if (t.u = void 0, typeof e == "function") {
    ee++;
    var n = P;
    P = void 0;
    try {
      e();
    } catch (s) {
      throw t.f &= -2, t.f |= 8, yt(t), s;
    } finally {
      P = n, Ve();
    }
  }
}
function yt(t) {
  for (var e = t.s; e !== void 0; e = e.n) e.S.U(e);
  t.x = void 0, t.s = void 0, wn(t);
}
function $r(t) {
  if (P !== this) throw new Error("Out-of-order effect");
  Nn(this), P = t, this.f &= -2, 8 & this.f && yt(this), Ve();
}
function Ie(t) {
  this.x = t, this.u = void 0, this.s = void 0, this.o = void 0, this.f = 32;
}
Ie.prototype.c = function () {
  var t = this.S();
  try {
    if (8 & this.f || this.x === void 0) return;
    var e = this.x();
    typeof e == "function" && (this.u = e);
  } finally {
    t();
  }
};
Ie.prototype.S = function () {
  1 & this.f && je(), this.f |= 1, this.f &= -9, wn(this), Pn(this), ee++;
  var t = P;
  return P = this, $r.bind(this, t);
};
Ie.prototype.N = function () {
  2 & this.f || (this.f |= 2, this.o = ye, ye = this);
};
Ie.prototype.d = function () {
  this.f |= 8, 1 & this.f || yt(this);
};
function W(t) {
  var e = new Ie(t);
  try {
    e.c();
  } catch (n) {
    throw e.d(), n;
  }
  return e.d.bind(e);
}
var Dn = /*#__PURE__*/function () {
  function Dn() {
    _classCallCheck(this, Dn);
    this.items = [];
  }
  _createClass(Dn, [{
    key: "enqueue",
    value: function enqueue(e) {
      this.items.push(e);
    }
  }, {
    key: "dequeue",
    value: function dequeue() {
      return this.items.length === 0 ? null : this.items.shift();
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.items.length === 0;
    }
  }, {
    key: "size",
    value: function size() {
      return this.items.length;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items = [];
    }
  }]);
  return Dn;
}();
var Oe = {
    LOG: 0,
    INFO: 1,
    DEBUG: 2,
    WARN: 3,
    ERROR: 4,
    NONE: 5
  },
  Ht = "ERROR",
  Br = "RS SDK",
  Gr = "font-weight: bold; background: black; color: white;",
  xr = "font-weight: normal;";
var Fr = /*#__PURE__*/function () {
  function Fr() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Ht;
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console;
    _classCallCheck(this, Fr);
    this.minLogLevel = Oe[e], this.scope = n, this.logProvider = s;
  }
  _createClass(Fr, [{
    key: "log",
    value: function log() {
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }
      this.outputLog("LOG", e);
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        e[_key3] = arguments[_key3];
      }
      this.outputLog("INFO", e);
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }
      this.outputLog("DEBUG", e);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        e[_key5] = arguments[_key5];
      }
      this.outputLog("WARN", e);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        e[_key6] = arguments[_key6];
      }
      this.outputLog("ERROR", e);
    }
  }, {
    key: "outputLog",
    value: function outputLog(e, n) {
      var _r3;
      var s, r;
      this.minLogLevel <= Oe[e] && ((r = (s = this.logProvider)[e.toLowerCase()]) == null || (_r3 = r).call.apply(_r3, [s].concat(_toConsumableArray(this.formatLogData(n)))));
    }
  }, {
    key: "setScope",
    value: function setScope(e) {
      this.scope = e || this.scope;
    }
    // TODO: should we allow to change the level via global variable on run time
    //  to assist on the fly debugging?
  }, {
    key: "setMinLogLevel",
    value: function setMinLogLevel(e) {
      this.minLogLevel = Oe[e], L(this.minLogLevel) && (this.minLogLevel = Oe[Ht]);
    }
    /**
    * Formats the console message using `scope` and styles
    */
  }, {
    key: "formatLogData",
    value: function formatLogData(e) {
      if (Array.isArray(e) && e.length > 0) {
        var n = "%c ".concat(Br);
        this.scope && (n = "".concat(n, " - ").concat(this.scope));
        var s = k(e[0]) ? e[0].trim() : "";
        n = "".concat(n, " %c ").concat(s);
        var r = [n, Gr,
        // add style for the prefix
        xr
        // reset the style for the actual message
        ];
        return k(e[0]) || r.push(e[0]), r.push.apply(r, _toConsumableArray(e.slice(1))), r;
      }
      return e;
    }
  }]);
  return Fr;
}();
var Q = new Fr(),
  kn = ["localStorage", "memoryStorage", "cookieStorage", "sessionStorage", "none"],
  it = "cookieStorage",
  Hr = '"getSourceConfig" must be a function. Please make sure that it is defined and returns a valid source configuration object.',
  jr = "Failed to load the SDK as the CDN base URL for integrations is not valid.",
  Vr = "Failed to load the SDK as the CDN base URL for plugins is not valid.",
  Qr = "Failed to load the SDK as the data plane URL could not be determined. Please check that the data plane URL is set correctly and try again.",
  jt = "Unable to process/parse source configuration response.",
  Kr = "Failed to prepare data for the request.",
  zr = "Failed to generate the event object.",
  Yr = "Failed to invoke plugin because the extension point name is missing.",
  Xr = "Failed to invoke plugin because the extension point name is invalid.",
  qr = function qr(t, e, n) {
    return "".concat(t).concat(S, "The consent manager \"").concat(e, "\" is not supported. Please choose one of the following supported consent managers: \"").concat(Object.keys(n), "\".");
  },
  Wr = function Wr(t) {
    return "".concat(t).concat(S, "Failed to initialize the error reporting plugin.");
  },
  Jr = function Jr(t) {
    return "".concat(t).concat(S, "Failed to notify the error.");
  },
  Zr = function Zr(t) {
    return "".concat(t).concat(S, "Plugin name is missing.");
  },
  ei = function ei(t, e) {
    return "".concat(t).concat(S, "Plugin \"").concat(e, "\" already exists.");
  },
  ti = function ti(t, e) {
    return "".concat(t).concat(S, "Plugin \"").concat(e, "\" not found.");
  },
  ni = function ni(t, e) {
    return "".concat(t).concat(S, "Plugin \"").concat(e, "\" not found in plugins but found in byName. This indicates a bug in the plugin engine. Please report this issue to the development team.");
  },
  si = function si(t, e, n) {
    return "".concat(t).concat(S, "Plugin \"").concat(e, "\" could not be loaded because some of its dependencies \"").concat(n, "\" do not exist.");
  },
  ri = function ri(t, e, n) {
    return "".concat(t).concat(S, "Failed to invoke the \"").concat(e, "\" extension point of plugin \"").concat(n, "\".");
  },
  ii = function ii(t, e) {
    return "".concat(t).concat(S, "The \"").concat(e, "\" storage type is ");
  },
  oi = function oi(t) {
    return "Failed to fetch the source config. Reason: ".concat(t);
  },
  ai = function ai(t) {
    return "The write key \"".concat(t, "\" is invalid. It must be a non-empty string. Please check that the write key is correct and try again.");
  },
  li = function li(t) {
    return "The data plane URL \"".concat(t, "\" is invalid. It must be a valid URL string. Please check that the data plane URL is correct and try again.");
  },
  ci = function ci(t) {
    return "".concat(t).concat(S, "The callback is not a function.");
  },
  ui = function ui(t, e, n, s) {
    return "".concat(t, " with status: ").concat(e, ", ").concat(n, " for URL: ").concat(s, ".");
  },
  di = function di(t, e, n) {
    return "".concat(t, " due to timeout or no connection (").concat(e ? e.type : "", ") for URL: ").concat(n, ".");
  },
  gi = function gi(t, e) {
    return "".concat(t, " for URL: ").concat(e);
  },
  hi = function hi(t) {
    return "Failed to save the value for \"".concat(t, "\" to storage");
  },
  fi = function fi(t) {
    return "Failed to retrieve or parse data for \"".concat(t, "\" from storage");
  },
  pi = function pi(t, e, n) {
    return "".concat(t).concat(S, "The storage type \"").concat(e, "\" is not supported. Please choose one of the following supported types: \"").concat(kn, "\". The default type \"").concat(n, "\" will be used instead.");
  },
  vi = function vi(t, e, n, s) {
    return "".concat(t).concat(S, "The error reporting provider \"").concat(e, "\" is not supported. Please choose one of the following supported providers: \"").concat(Object.keys(n), "\". The default provider \"").concat(s, "\" will be used instead.");
  },
  Ei = function Ei(t, e, n, s) {
    return "".concat(t).concat(S, "The storage encryption version \"").concat(e, "\" is not supported. Please choose one of the following supported versions: \"").concat(Object.keys(n), "\". The default version \"").concat(s, "\" will be used instead.");
  },
  mi = function mi(t, e, n) {
    return "".concat(t).concat(S, "The storage data migration has been disabled because the configured storage encryption version (").concat(e, ") is not the latest (").concat(n, "). To enable storage data migration, please update the storage encryption version to the latest version.");
  },
  yi = function yi(t, e, n) {
    return "".concat(t).concat(S, "The residency server region \"").concat(e, "\" is not supported. Please choose one of the following supported regions: \"US, EU\". The default region \"").concat(n, "\" will be used instead.");
  },
  Si = function Si(t, e, n, s) {
    return "".concat(t).concat(S, "The \"").concat(e, "\" property defined under \"").concat(n, "\" is a reserved keyword. Please choose a different property name to avoid conflicts with reserved keywords (").concat(s, ").");
  },
  _i = function _i(t) {
    return "".concat(t).concat(S, "Please make sure that the \"context\" property in the event API's \"options\" argument is a valid object literal with key-value pairs.");
  },
  Ii = function Ii(t) {
    return "".concat(t).concat(S, "The Beacon API is not supported by your browser. The events will be sent using XHR instead.");
  },
  bi = function bi(t, e, n) {
    return "".concat(t).concat(S, "The session timeout value \"").concat(e, "\" is not a number. The default timeout of ").concat(n, " ms will be used instead.");
  },
  Ti = function Ti(t) {
    return "".concat(t).concat(S, "The session timeout value is 0, which disables the automatic session tracking feature. If you want to enable session tracking, please provide a positive integer value for the timeout.");
  },
  Ri = function Ri(t, e, n) {
    return "".concat(t).concat(S, "The session timeout value ").concat(e, " ms is less than the recommended minimum of ").concat(n, " ms. Please consider increasing the timeout value to ensure optimal performance and reliability.");
  },
  Ai = function Ai(t, e, n) {
    return "".concat(t).concat(S, "The provided session ID (").concat(e, ") is either invalid, not a positive integer, or not at least \"").concat(n, "\" digits long. A new session ID will be auto-generated instead.");
  },
  Oi = function Oi(t) {
    return "".concat(t).concat(S, "The storage is either full or unavailable, so the data will not be persisted. Switching to in-memory storage.");
  },
  Pi = function Pi(t, e, n, s) {
    return "".concat(t).concat(S, "The storage type \"").concat(n, "\" is not available for entry \"").concat(e, "\". The SDK will initialize the entry with \"").concat(s, "\" storage type instead.");
  },
  Ni = function Ni(t, e) {
    return "".concat(t).concat(S, "The write key \"").concat(e, "\" is not a string. Please check that the write key is correct and try again.");
  },
  wi = function wi(t) {
    return "".concat(t).concat(S, "The group() method must be called with at least one argument.");
  },
  Vt = "Failed to invoke the ready callback",
  Di = "API Callback Invocation Failed",
  ki = "NativeDestinationQueuePlugin initialization failed",
  Li = "XhrQueuePlugin initialization failed",
  Ci = "DeviceModeTransformationPlugin initialization failed",
  Ui = "NativeDestinationQueuePlugin event enqueue failed",
  Mi = "XhrQueuePlugin event enqueue failed",
  $i = function $i(t, e) {
    return "".concat(t).concat(S, "The provided config URL \"").concat(e, "\" is invalid. Using the default value instead.");
  },
  Bi = function Bi(t, e) {
    return "Failed to load the polyfill script with ID \"".concat(t, "\" from URL ").concat(e, ".");
  },
  Gi = "Failed to encode the cookie data.",
  xi = function xi(t, e, n) {
    return "".concat(t).concat(S, "The pre-consent storage strategy \"").concat(e, "\" is not supported. Please choose one of the following supported strategies: \"none, session, anonymousId\". The default strategy \"").concat(n, "\" will be used instead.");
  },
  Fi = function Fi(t, e, n) {
    return "".concat(t).concat(S, "The pre-consent events delivery type \"").concat(e, "\" is not supported. Please choose one of the following supported types: \"immediate, buffer\". The default type \"").concat(n, "\" will be used instead.");
  },
  Hi = function Hi(t, e, n, s) {
    var r = n.length === 1 ? " '".concat(n[0], "' plugin was") : " ['".concat(n.join("', '"), "'] plugins were"),
      i = "".concat(t).concat(S).concat(e, ", but").concat(r, " not configured to load.");
    var a;
    return s ? a = "".concat(i, " So, ").concat(n.length === 1 ? "the plugin" : "those plugins", " will be loaded automatically.") : a = "".concat(i, " Ignore if this was intentional. Otherwise, consider adding ").concat(n.length === 1 ? "it" : "them", " to the 'plugins' load API option."), a;
  },
  Ln = "js-integrations",
  Cn = "plugins",
  St = "modern",
  Un = "https://cdn.rudderlabs.com",
  _t = "v3",
  Mn = "".concat(Un, "/").concat(_t, "/").concat(St, "/").concat(Ln),
  $n = "".concat(Un, "/").concat(_t, "/").concat(St, "/").concat(Cn),
  Bn = "https://api.rudderstack.com",
  ot = "bugsnag",
  se = "v3",
  ji = "xhr",
  at = {
    oneTrust: "OneTrustConsentManager",
    ketch: "KetchConsentManager",
    custom: "CustomConsentManager"
  },
  Ne = _defineProperty({}, ot, "Bugsnag"),
  we = (_we = {}, _defineProperty(_we, se, "StorageEncryption"), _defineProperty(_we, "legacy", "StorageEncryptionLegacy"), _we),
  Vi = (_Vi = {}, _defineProperty(_Vi, ji, "XhrQueue"), _defineProperty(_Vi, "beacon", "BeaconQueue"), _Vi),
  Qi = {
    logLevel: "ERROR",
    configUrl: Bn,
    loadIntegration: !0,
    sessions: {
      autoTrack: !0,
      timeout: Se
    },
    sameSiteCookie: "Lax",
    polyfillIfRequired: !0,
    integrations: {
      All: !0
    },
    useBeacon: !1,
    beaconQueueOptions: {},
    destinationsQueueOptions: {},
    queueOptions: {},
    lockIntegrationsVersion: !1,
    uaChTrackLevel: "none",
    plugins: [],
    useGlobalIntegrationsConfigInEvents: !1,
    bufferDataPlaneEventsUntilReady: !1,
    dataPlaneEventsBufferTimeout: vr,
    storage: {
      encryption: {
        version: se
      },
      migrate: !0
    },
    sendAdblockPageOptions: {}
  },
  Ki = u(I(Qi)),
  ue = {
    userId: "rl_user_id",
    userTraits: "rl_trait",
    anonymousId: "rl_anonymous_id",
    groupId: "rl_group_id",
    groupTraits: "rl_group_trait",
    initialReferrer: "rl_page_init_referrer",
    initialReferringDomain: "rl_page_init_referring_domain",
    sessionInfo: "rl_session",
    authToken: "rl_auth_token"
  },
  R = {
    userId: "",
    userTraits: {},
    anonymousId: "",
    groupId: "",
    groupTraits: {},
    initialReferrer: "",
    initialReferringDomain: "",
    sessionInfo: {},
    authToken: null
  },
  zi = {
    autoTrack: !0,
    timeout: Se
  },
  Yi = {
    userId: u(R.userId),
    userTraits: u(R.userTraits),
    anonymousId: u(R.anonymousId),
    groupId: u(R.groupId),
    groupTraits: u(R.groupTraits),
    initialReferrer: u(R.initialReferrer),
    initialReferringDomain: u(R.initialReferringDomain),
    sessionInfo: u(R.sessionInfo),
    authToken: u(R.authToken)
  },
  Xi = {
    isOnline: u(!0),
    storage: {
      isLocalStorageAvailable: u(!1),
      isCookieStorageAvailable: u(!1),
      isSessionStorageAvailable: u(!1)
    },
    isBeaconAvailable: u(!1),
    isLegacyDOM: u(!1),
    isUaCHAvailable: u(!1),
    isCryptoAvailable: u(!1),
    isIE11: u(!1),
    isAdBlocked: u(!1)
  },
  qi = {
    isErrorReportingEnabled: u(!1),
    isMetricsReportingEnabled: u(!1),
    errorReportingProviderPluginName: u(void 0),
    isErrorReportingPluginLoaded: u(!1)
  },
  Wi = u(void 0),
  Ji = {
    activeDataplaneUrl: u(void 0),
    integrationsCDNPath: u(Mn),
    pluginsCDNPath: u($n),
    sourceConfigUrl: u(void 0),
    status: u(void 0),
    initialized: u(!1),
    logLevel: u("ERROR"),
    loaded: u(!1),
    readyCallbacks: u([]),
    writeKey: u(void 0),
    dataPlaneUrl: u(void 0)
  },
  Zi = {
    enabled: u(!1),
    initialized: u(!1),
    data: u({}),
    activeConsentManagerPluginName: u(void 0),
    preConsent: u({
      enabled: !1
    }),
    postConsent: u({}),
    resolutionStrategy: u("and"),
    provider: u(void 0),
    metadata: u(void 0)
  },
  eo = {
    retries: u(0),
    dropped: u(0),
    sent: u(0),
    queued: u(0),
    triggered: u(0)
  },
  to = {
    app: u({
      name: Ct,
      namespace: ar,
      version: Me
    }),
    traits: u(null),
    library: u({
      name: Ct,
      version: Me,
      snippetVersion: globalThis.RudderSnippetVersion
    }),
    userAgent: u(""),
    device: u(null),
    network: u(null),
    os: u({
      name: "",
      version: ""
    }),
    locale: u(null),
    screen: u({
      density: 0,
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0
    }),
    "ua-ch": u(void 0),
    timezone: u(void 0)
  },
  no = {
    configuredDestinations: u([]),
    activeDestinations: u([]),
    loadOnlyIntegrations: u({}),
    failedDestinations: u([]),
    loadIntegration: u(!0),
    initializedDestinations: u([]),
    clientDestinationsReady: u(!1),
    integrationsConfig: u({})
  },
  so = {
    toBeProcessedArray: u([]),
    readyCallbacksArray: u([])
  },
  ro = {
    ready: u(!1),
    loadedPlugins: u([]),
    failedPlugins: u([]),
    pluginsToLoadFromConfig: u([]),
    activePlugins: u([]),
    totalPluginsToLoad: u(0)
  },
  io = {
    encryptionPluginName: u(void 0),
    migrate: u(!1),
    type: u(void 0),
    cookie: u(void 0),
    entries: u({}),
    trulyAnonymousTracking: u(!1)
  },
  oo = {
    eventsQueuePluginName: u(void 0),
    deliveryEnabled: u(!0)
    // Delivery should always happen
  },
  ao = {
    capabilities: Xi,
    consents: Zi,
    context: to,
    eventBuffer: so,
    lifecycle: Ji,
    loadOptions: Ki,
    metrics: eo,
    nativeDestinations: no,
    plugins: ro,
    reporting: qi,
    session: Yi,
    source: Wi,
    storage: io,
    dataPlaneEvents: oo
  },
  o = _objectSpread({}, I(ao));
var lo = /*#__PURE__*/function () {
  function lo() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var n = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, lo);
    _(this, "plugins", []);
    _(this, "byName", {});
    _(this, "cache", {});
    _(this, "config", {
      throws: !0
    });
    this.config = _objectSpread({
      throws: !0
    }, e), this.logger = n;
  }
  _createClass(lo, [{
    key: "register",
    value: function register(e, n) {
      var r, i;
      if (!e.name) {
        var a = Zr(le);
        if (this.config.throws) throw new Error(a);
        (r = this.logger) == null || r.error(a, e);
      }
      if (this.byName[e.name]) {
        var _a2 = ei(le, e.name);
        if (this.config.throws) throw new Error(_a2);
        (i = this.logger) == null || i.error(_a2);
      }
      this.cache = {}, this.plugins = this.plugins.slice();
      var s = this.plugins.length;
      this.plugins.forEach(function (a, l) {
        var c;
        (c = a.deps) != null && c.includes(e.name) && (s = Math.min(s, l));
      }), this.plugins.splice(s, 0, e), this.byName[e.name] = e, f(e.initialize) && e.initialize(n);
    }
  }, {
    key: "unregister",
    value: function unregister(e) {
      var r, i;
      var n = this.byName[e];
      if (!n) {
        var a = ti(le, e);
        if (this.config.throws) throw new Error(a);
        (r = this.logger) == null || r.error(a);
      }
      var s = this.plugins.indexOf(n);
      if (s === -1) {
        var _a3 = ni(le, e);
        if (this.config.throws) throw new Error(_a3);
        (i = this.logger) == null || i.error(_a3);
      }
      this.cache = {}, delete this.byName[e], this.plugins = this.plugins.slice(), this.plugins.splice(s, 1);
    }
  }, {
    key: "getPlugin",
    value: function getPlugin(e) {
      return this.byName[e];
    }
  }, {
    key: "getPlugins",
    value: function getPlugins(e) {
      var _this2 = this;
      var n = e !== null && e !== void 0 ? e : ".";
      return this.cache[n] || (this.cache[n] = this.plugins.filter(function (s) {
        var r, i;
        if ((r = s.deps) != null && r.some(function (a) {
          return !_this2.byName[a];
        })) {
          var a = s.deps.filter(function (l) {
            return !_this2.byName[l];
          });
          return (i = _this2.logger) == null || i.error(si(le, s.name, a)), !1;
        }
        return n === "." ? !0 : Ws(s, n);
      })), this.cache[n];
    }
    // This method allows to process this.plugins so that it could
    // do some unified pre-process before application starts.
  }, {
    key: "processRawPlugins",
    value: function processRawPlugins(e) {
      e(this.plugins), this.cache = {};
    }
  }, {
    key: "invoke",
    value: function invoke(e) {
      var _this$config$throws,
        _this3 = this;
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      for (var _len7 = arguments.length, s = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        s[_key7 - 2] = arguments[_key7];
      }
      var r = e;
      if (!r) throw new Error(Yr);
      var i = r.startsWith("!"),
        a = (_this$config$throws = this.config.throws) !== null && _this$config$throws !== void 0 ? _this$config$throws : r.endsWith("!");
      if (r = r.replace(/(^!|!$)/g, ""), !r) throw new Error(Xr);
      var l = r.split(".");
      l.pop();
      var c = l.join(".");
      return (n ? this.getPlugins(r) : [this.getPlugins(r)[0]]).map(function (p) {
        var N;
        var m = nt(p, r);
        if (!f(m) || i) return m;
        try {
          return m.apply(nt(p, c), s);
        } catch (g) {
          if (a) throw g;
          (N = _this3.logger) == null || N.error(ri(le, r, p.name), g);
        }
        return null;
      });
    }
  }, {
    key: "invokeSingle",
    value: function invokeSingle(e) {
      for (var _len8 = arguments.length, n = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        n[_key8 - 1] = arguments[_key8];
      }
      return this.invoke.apply(this, [e, !1].concat(n))[0];
    }
  }, {
    key: "invokeMultiple",
    value: function invokeMultiple(e) {
      for (var _len9 = arguments.length, n = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        n[_key9 - 1] = arguments[_key9];
      }
      return this.invoke.apply(this, [e, !0].concat(n));
    }
  }]);
  return lo;
}();
var Gn = new lo({
    throws: !0
  }, Q),
  De = "The request failed",
  co = [De],
  uo = "RS_JS_SDK",
  go = function go(t) {
    var e;
    try {
      if (k(t)) e = t;else if (t instanceof Error) e = t.message;else if (t instanceof ErrorEvent) e = t.message;else if (t instanceof Event) {
        var n = t.target;
        if (n && n.localName !== "script" || n != null && n.dataset && (n.dataset.loader !== uo || n.dataset.isnonnativesdk !== "true")) return "";
        e = "Error in loading a third-party script from URL ".concat(n == null ? void 0 : n.src, " with ID ").concat(n == null ? void 0 : n.id, ".");
      } else e = t.message ? t.message : He(t);
    } catch (n) {
      e = "Unknown error: ".concat(n.message);
    }
    return e;
  },
  ho = function ho(t) {
    return t.message ? !co.some(function (e) {
      return t.message.includes(e);
    }) : !0;
  };
var fo = /*#__PURE__*/function () {
  // If no logger is passed errors will be thrown as unhandled error
  function fo(e, n) {
    _classCallCheck(this, fo);
    this.logger = e, this.pluginEngine = n, this.errorBuffer = new Dn(), this.attachEffect();
  }
  _createClass(fo, [{
    key: "attachEffect",
    value: function attachEffect() {
      if (o.reporting.isErrorReportingPluginLoaded.value === !0) for (; this.errorBuffer.size() > 0;) this.errorBuffer.dequeue();
    }
  }, {
    key: "attachErrorListeners",
    value: function attachErrorListeners() {
      var _this4 = this;
      var e;
      "addEventListener" in globalThis ? (globalThis.addEventListener("error", function (n) {
        _this4.onError(n, void 0, void 0, void 0, "unhandledException");
      }), globalThis.addEventListener("unhandledrejection", function (n) {
        _this4.onError(n, void 0, void 0, void 0, "unhandledPromiseRejection");
      })) : (e = this.logger) == null || e.debug("Failed to attach global error listeners.");
    }
  }, {
    key: "init",
    value: function init(e) {
      var _this5 = this;
      if (this.pluginEngine) try {
        var s = this.pluginEngine.invokeSingle("errorReporting.init", o, this.pluginEngine, e, this.logger);
        s instanceof Promise && s.then(function (r) {
          _this5.errReportingClient = r;
        }).catch(function (r) {
          var i;
          (i = _this5.logger) == null || i.error(Wr(Ae), r);
        });
      } catch (n) {
        this.onError(n, Ae);
      }
    }
  }, {
    key: "onError",
    value: function onError(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "handled";
      var a = go(e);
      if (!a) return;
      a = er("".concat(n).concat(S).concat(s, " ").concat(a));
      var l = new Error(a);
      if (mn(e) && (l = Object.create(e, {
        message: {
          value: a
        }
      })), i === "handled") if (this.notifyError(l), this.logger) {
        if (this.logger.error(a), r) throw l;
      } else throw l;
      o.reporting.isErrorReportingEnabled.value && o.reporting.isErrorReportingPluginLoaded.value;
    }
    /**
    * Add breadcrumbs to add insight of a user's journey before an error
    * occurred and send to external error monitoring service via a plugin
    *
    * @param {string} breadcrumb breadcrumbs message
    */
  }, {
    key: "leaveBreadcrumb",
    value: function leaveBreadcrumb(e) {
      if (this.pluginEngine) try {
        this.pluginEngine.invokeSingle("errorReporting.breadcrumb", this.pluginEngine, this.errReportingClient, e, this.logger);
      } catch (n) {
        this.onError(n, Ae, "errorReporting.breadcrumb");
      }
    }
    /**
    * Send handled errors to external error monitoring service via a plugin
    *
    * @param {Error} error Error instance from handled error
    */
  }, {
    key: "notifyError",
    value: function notifyError(e) {
      var n;
      if (this.pluginEngine && ho(e)) try {
        this.pluginEngine.invokeSingle("errorReporting.notify", this.pluginEngine, this.errReportingClient, e, o, this.logger);
      } catch (s) {
        (n = this.logger) == null || n.error(Jr(Ae), s);
      }
    }
  }]);
  return fo;
}();
var Qe = new fo(Q, Gn),
  po = function po(t) {
    return t.config.connectionMode !== "cloud" || t.config.useNativeSDKToSend === !0 ||
    // this is the older flag for hybrid mode destinations
    t.config.useNativeSDK === !0;
  },
  vo = function vo(t) {
    return t.config.connectionMode === "hybrid" || t.config.useNativeSDKToSend === !0;
  },
  Qt = function Qt(t) {
    return t.filter(po);
  },
  xn = ["BeaconQueue", "Bugsnag", "CustomConsentManager", "DeviceModeDestinations", "DeviceModeTransformation", "ErrorReporting", "ExternalAnonymousId", "GoogleLinker", "KetchConsentManager", "NativeDestinationQueue", "OneTrustConsentManager", "StorageEncryption", "StorageEncryptionLegacy", "StorageMigrator", "XhrQueue"],
  Eo = {
    rudderAnalyticsRemotePlugins: {
      url: function url() {
        return Promise.resolve(window.RudderStackGlobals && window.RudderStackGlobals.app && window.RudderStackGlobals.app.pluginsCDNPath ? "" + window.RudderStackGlobals.app.pluginsCDNPath + "/rsa-plugins.js" : "https://cdn.rudderlabs.com/3.1.1/modern/plugins/rsa-plugins.js");
      },
      format: "esm",
      from: "vite"
    }
  },
  mo = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(t, e) {
      var n, s;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof t == "function")) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return t();
          case 3:
            _context.t0 = _context.sent;
            _context.next = 7;
            break;
          case 6:
            _context.t0 = t;
          case 7:
            n = _context.t0;
            s = document.createElement("script");
            s.type = "text/javascript", s.onload = e, s.src = n, document.getElementsByTagName("head")[0].appendChild(s);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function mo(_x, _x2) {
      return _ref7.apply(this, arguments);
    };
  }();
function Fn(t, e) {
  var n = Object.assign(t, e);
  for (var _i3 = 0, _Object$keys = Object.keys(n); _i3 < _Object$keys.length; _i3++) {
    var s = _Object$keys[_i3];
    _typeof(n[s]) == "object" && _typeof(e[s]) == "object" && (n[s] = Fn(n[s], e[s]));
  }
  return n;
}
var Kt = function Kt(t) {
  return Fn({}, (globalThis.__federation_shared__ || {}).default || {});
};
function yo(_x3) {
  return _yo.apply(this, arguments);
}
function _yo() {
  _yo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(t) {
    var e;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          e = Eo[t];
          if (!e.inited) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return", e.lib);
        case 3:
          if (!(e.format === "var")) {
            _context4.next = 5;
            break;
          }
          return _context4.abrupt("return", new Promise(function (n) {
            var s = function s() {
              e.inited || (e.lib = window[t], e.lib.init(Kt(e.from)), e.inited = !0), n(e.lib);
            };
            return mo(e.url, s);
          }));
        case 5:
          if (!["esm", "systemjs"].includes(e.format)) {
            _context4.next = 7;
            break;
          }
          return _context4.abrupt("return", new Promise(function (n, s) {
            (typeof e.url == "function" ? e.url : function () {
              return Promise.resolve(e.url);
            })().then(function (i) {
              import( /* webpackIgnore: true */
              /* @vite-ignore */
              i).then(function (a) {
                if (!e.inited) {
                  var l = Kt(e.from);
                  a.init(l), e.lib = a, e.lib.init(l), e.inited = !0;
                }
                n(e.lib);
              }).catch(s);
            });
          }));
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _yo.apply(this, arguments);
}
function C(t, e) {
  if (!(t != null && t.default) && e) {
    var n = /* @__PURE__ */Object.create(null);
    return n.default = t, n.__esModule = !0, n;
  }
  return t;
}
function U(t, e) {
  return yo(t).then(function (n) {
    return n.get(e).then(function (s) {
      return s();
    });
  });
}
var So = function So(t) {
    switch (t) {
      case "BeaconQueue":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./BeaconQueue").then(function (e) {
            return C(e, !0);
          });
        };
      case "Bugsnag":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./Bugsnag").then(function (e) {
            return C(e, !0);
          });
        };
      case "CustomConsentManager":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./CustomConsentManager").then(function (e) {
            return C(e, !0);
          });
        };
      case "DeviceModeDestinations":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./DeviceModeDestinations").then(function (e) {
            return C(e, !0);
          });
        };
      case "DeviceModeTransformation":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./DeviceModeTransformation").then(function (e) {
            return C(e, !0);
          });
        };
      case "ErrorReporting":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./ErrorReporting").then(function (e) {
            return C(e, !0);
          });
        };
      case "ExternalAnonymousId":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./ExternalAnonymousId").then(function (e) {
            return C(e, !0);
          });
        };
      case "GoogleLinker":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./GoogleLinker").then(function (e) {
            return C(e, !0);
          });
        };
      case "KetchConsentManager":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./KetchConsentManager").then(function (e) {
            return C(e, !0);
          });
        };
      case "NativeDestinationQueue":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./NativeDestinationQueue").then(function (e) {
            return C(e, !0);
          });
        };
      case "OneTrustConsentManager":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./OneTrustConsentManager").then(function (e) {
            return C(e, !0);
          });
        };
      case "StorageEncryption":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./StorageEncryption").then(function (e) {
            return C(e, !0);
          });
        };
      case "StorageEncryptionLegacy":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./StorageEncryptionLegacy").then(function (e) {
            return C(e, !0);
          });
        };
      case "StorageMigrator":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./StorageMigrator").then(function (e) {
            return C(e, !0);
          });
        };
      case "XhrQueue":
        return function () {
          return U("rudderAnalyticsRemotePlugins", "./XhrQueue").then(function (e) {
            return C(e, !0);
          });
        };
      default:
        return;
    }
  },
  Xe = function Xe(t) {
    var e = {};
    return t.forEach(function (n) {
      if (xn.includes(n)) {
        var s = So(n);
        s && (e[n] = s);
      }
    }), e;
  },
  lt = function lt() {
    return {};
  },
  _o = function _o() {
    return {};
  },
  Io = function Io(t) {
    return (Xe == null ? void 0 : Xe(t)) || {};
  },
  qe = _objectSpread(_objectSpread({}, lt()), _o()),
  bo = function bo(t) {
    return _objectSpread({}, Io(t));
  };
var To = /*#__PURE__*/function () {
  function To(e, n, s) {
    _classCallCheck(this, To);
    this.engine = e, this.errorHandler = n, this.logger = s, this.onError = this.onError.bind(this);
  }
  /**
  * Orchestrate the plugin loading and registering
  */
  _createClass(To, [{
    key: "init",
    value: function init() {
      o.lifecycle.status.value = "pluginsLoading", Fe("pluginsCDNPath", o.lifecycle.pluginsCDNPath.value), this.setActivePlugins(), this.registerLocalPlugins(), this.registerRemotePlugins(), this.attachEffects();
    }
    /**
    * Update state based on plugin loaded status
    */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "attachEffects",
    value: function attachEffects() {
      W(function () {
        (o.plugins.activePlugins.value.length === 0 || o.plugins.loadedPlugins.value.length + o.plugins.failedPlugins.value.length === o.plugins.totalPluginsToLoad.value) && M(function () {
          o.plugins.ready.value = !0, o.lifecycle.status.value = "pluginsReady";
        });
      });
    }
    /**
    * Determine the list of plugins that should be loaded based on sourceConfig & load options
    */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getPluginsToLoadBasedOnConfig",
    value: function getPluginsToLoadBasedOnConfig() {
      var _this6 = this;
      var e = o.plugins.pluginsToLoadFromConfig.value;
      if (!e) return [];
      var n = [{
          configurationStatus: function configurationStatus() {
            return A(o.dataPlaneEvents.eventsQueuePluginName.value);
          },
          configurationStatusStr: "Data plane events delivery is enabled",
          activePluginName: o.dataPlaneEvents.eventsQueuePluginName.value,
          supportedPlugins: Object.values(Vi),
          shouldAddMissingPlugins: !0
        }, {
          configurationStatus: function configurationStatus() {
            return A(o.reporting.errorReportingProviderPluginName.value);
          },
          configurationStatusStr: "Error reporting is enabled",
          activePluginName: o.reporting.errorReportingProviderPluginName.value,
          basePlugins: ["ErrorReporting"],
          supportedPlugins: Object.values(Ne)
        }, {
          configurationStatus: function configurationStatus() {
            return Qt(o.nativeDestinations.configuredDestinations.value).length > 0;
          },
          configurationStatusStr: "Device mode destinations are connected to the source",
          supportedPlugins: ["DeviceModeDestinations", "NativeDestinationQueue"]
        }, {
          configurationStatus: function configurationStatus() {
            return Qt(o.nativeDestinations.configuredDestinations.value).some(function (r) {
              return r.shouldApplyDeviceModeTransformation;
            });
          },
          configurationStatusStr: "Device mode transformations are enabled for at least one destination",
          supportedPlugins: ["DeviceModeTransformation"]
        }, {
          configurationStatus: function configurationStatus() {
            return A(o.consents.activeConsentManagerPluginName.value);
          },
          configurationStatusStr: "Consent management is enabled",
          activePluginName: o.consents.activeConsentManagerPluginName.value,
          supportedPlugins: Object.values(at)
        }, {
          configurationStatus: function configurationStatus() {
            return A(o.storage.encryptionPluginName.value);
          },
          configurationStatusStr: "Storage encryption is enabled",
          activePluginName: o.storage.encryptionPluginName.value,
          supportedPlugins: Object.values(we)
        }, {
          configurationStatus: function configurationStatus() {
            return o.storage.migrate.value;
          },
          configurationStatusStr: "Storage migration is enabled",
          supportedPlugins: ["StorageMigrator"]
        }],
        s = !1;
      return n.forEach(function (r) {
        r.configurationStatus() ? (e = e.filter(r.activePluginName ? function (i) {
          return !(i !== r.activePluginName && r.supportedPlugins.includes(i));
        } : function (i) {
          return A(i);
        }
        // pass through
        ), _this6.addMissingPlugins(r, s, e)) : e = e.filter(r.basePlugins !== void 0 ? function (i) {
          return !(r.basePlugins.includes(i) || r.supportedPlugins.includes(i));
        } : function (i) {
          return !r.supportedPlugins.includes(i);
        });
      }), [].concat(_toConsumableArray(Object.keys(lt())), _toConsumableArray(e));
    }
  }, {
    key: "addMissingPlugins",
    value: function addMissingPlugins(e, n, s) {
      var l;
      var r = e.shouldAddMissingPlugins || n;
      var i;
      e.activePluginName ? i = [].concat(_toConsumableArray(e.basePlugins || []), [e.activePluginName]) : i = _toConsumableArray(e.supportedPlugins);
      var a = i.filter(function (c) {
        return !s.includes(c);
      });
      a.length > 0 && (r && s.push.apply(s, _toConsumableArray(a)), (l = this.logger) == null || l.warn(Hi(Dt, e.configurationStatusStr, a, r)));
    }
    /**
    * Determine the list of plugins that should be activated
    */
  }, {
    key: "setActivePlugins",
    value: function setActivePlugins() {
      var e = this.getPluginsToLoadBasedOnConfig(),
        n = [].concat(_toConsumableArray(Object.keys(qe)), xn),
        s = [],
        r = [];
      e.forEach(function (i) {
        n.includes(i) ? s.push(i) : r.push(i);
      }), r.length > 0 && this.onError(new Error("Ignoring loading of unknown plugins: ".concat(r.join(","), ". Mandatory plugins: ").concat(Object.keys(lt()).join(","), ". Load option plugins: ").concat(o.plugins.pluginsToLoadFromConfig.value.join(",")))), M(function () {
        o.plugins.totalPluginsToLoad.value = e.length, o.plugins.activePlugins.value = s, o.plugins.failedPlugins.value = r;
      });
    }
    /**
    * Register plugins that are direct imports to PluginEngine
    */
  }, {
    key: "registerLocalPlugins",
    value: function registerLocalPlugins() {
      var _this7 = this;
      Object.values(qe).forEach(function (e) {
        f(e) && o.plugins.activePlugins.value.includes(e().name) && _this7.register([e()]);
      });
    }
    /**
    * Register plugins that are dynamic imports to PluginEngine
    */
  }, {
    key: "registerRemotePlugins",
    value: function registerRemotePlugins() {
      var _this8 = this;
      var e = bo(o.plugins.activePlugins.value);
      Promise.all(Object.keys(e).map( /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(n) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return e[n]().then(function (s) {
                  return _this8.register([s.default()]);
                }).catch(function (s) {
                  o.plugins.failedPlugins.value = [].concat(_toConsumableArray(o.plugins.failedPlugins.value), [n]), _this8.onError(s, n);
                });
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x4) {
          return _ref8.apply(this, arguments);
        };
      }())).catch(function (n) {
        _this8.onError(n);
      });
    }
    /**
    * Extension point invoke that allows multiple plugins to be registered to it with error handling
    */
  }, {
    key: "invokeMultiple",
    value: function invokeMultiple(e) {
      try {
        var _this$engine;
        for (var _len10 = arguments.length, n = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
          n[_key10 - 1] = arguments[_key10];
        }
        return (_this$engine = this.engine).invokeMultiple.apply(_this$engine, [e].concat(n));
      } catch (s) {
        return this.onError(s, e), [];
      }
    }
    /**
    * Extension point invoke that allows a single plugin to be registered to it with error handling
    */
  }, {
    key: "invokeSingle",
    value: function invokeSingle(e) {
      try {
        var _this$engine2;
        for (var _len11 = arguments.length, n = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
          n[_key11 - 1] = arguments[_key11];
        }
        return (_this$engine2 = this.engine).invokeSingle.apply(_this$engine2, [e].concat(n));
      } catch (s) {
        return this.onError(s, e), null;
      }
    }
    /**
    * Plugin engine register with error handling
    */
  }, {
    key: "register",
    value: function register(e) {
      var _this9 = this;
      e.forEach(function (n) {
        try {
          _this9.engine.register(n, o);
        } catch (s) {
          o.plugins.failedPlugins.value = [].concat(_toConsumableArray(o.plugins.failedPlugins.value), [n.name]), _this9.onError(s);
        }
      });
    }
    // TODO: Implement reset API instead
  }, {
    key: "unregisterLocalPlugins",
    value: function unregisterLocalPlugins() {
      var _this10 = this;
      Object.values(qe).forEach(function (e) {
        try {
          _this10.engine.unregister(e().name);
        } catch (n) {
          _this10.onError(n);
        }
      });
    }
    /**
    * Handle errors
    */
  }, {
    key: "onError",
    value: function onError(e, n) {
      if (this.errorHandler) this.errorHandler.onError(e, Dt, n);else throw e;
    }
  }]);
  return To;
}();
var zt = function zt(t, e) {
    try {
      return JSON.parse(t || "");
    } catch (n) {
      var s = _e(n, "Failed to parse response data");
      if (f(e)) e(s);else throw s;
    }
  },
  Ro = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8"
    },
    method: "GET"
  },
  Yt = function Yt(t, e, n) {
    var s = w(Ro, e || {});
    return n && (s.headers = w(s.headers, {
      Authorization: n
    })), s.url = t, s;
  },
  Xt = function Xt(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fr;
    var n = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function (s, r) {
      var i;
      if (t.sendRawData === !0) i = t.data;else if (i = He(t.data, !1, [], n), H(i)) {
        r({
          error: new Error(Kr),
          undefined: void 0,
          options: t
        });
        return;
      }
      var a = new XMLHttpRequest(),
        l = function l(d) {
          r({
            error: new Error(ui(De, a.status, a.statusText, t.url)),
            xhr: a,
            options: t
          });
        },
        c = function c(d) {
          r({
            error: new Error(di(De, d, t.url)),
            xhr: a,
            options: t
          });
        };
      a.ontimeout = c, a.onerror = c, a.onload = function () {
        a.status >= 200 && a.status < 400 ? s({
          response: a.responseText,
          xhr: a,
          options: t
        }) : l();
      }, a.open(t.method, t.url), a.timeout = e, Object.keys(t.headers).forEach(function (d) {
        t.headers[d] && a.setRequestHeader(d, t.headers[d]);
      });
      try {
        a.send(i);
      } catch (d) {
        r({
          error: _e(d, gi(De, t.url)),
          xhr: a,
          options: t
        });
      }
    });
  };
var It = /*#__PURE__*/function () {
  function It(e, n) {
    _classCallCheck(this, It);
    _(this, "hasErrorHandler", !1);
    this.errorHandler = e, this.logger = n, this.hasErrorHandler = !!this.errorHandler, this.onError = this.onError.bind(this);
  }
  /**
  * Implement requests in a blocking way
  */
  _createClass(It, [{
    key: "getData",
    value: (function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        var n, s, r, i, a, _a$error;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              n = e.url, s = e.options, r = e.timeout, i = e.isRawResponse;
              _context3.prev = 1;
              _context3.next = 4;
              return Xt(Yt(n, s, this.basicAuthHeader), r, this.logger);
            case 4:
              a = _context3.sent;
              return _context3.abrupt("return", {
                data: i ? a.response : zt(a.response, this.onError),
                details: a
              });
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return", (this.onError((_a$error = _context3.t0.error) !== null && _a$error !== void 0 ? _a$error : _context3.t0), {
                data: void 0,
                details: _context3.t0
              }));
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 8]]);
      }));
      function getData(_x5) {
        return _getData.apply(this, arguments);
      }
      return getData;
    }()
    /**
    * Implement requests in a non-blocking way
    */
    )
  }, {
    key: "getAsyncData",
    value: function getAsyncData(e) {
      var _this11 = this;
      var n = e.callback,
        s = e.url,
        r = e.options,
        i = e.timeout,
        a = e.isRawResponse,
        l = !f(n);
      Xt(Yt(s, r, this.basicAuthHeader), i, this.logger).then(function (c) {
        l || n(a ? c.response : zt(c.response, _this11.onError), c);
      }).catch(function (c) {
        var _c$error;
        _this11.onError((_c$error = c.error) !== null && _c$error !== void 0 ? _c$error : c), l || n(void 0, c);
      });
    }
    /**
    * Handle errors
    */
  }, {
    key: "onError",
    value: function onError(e) {
      var n;
      if (this.hasErrorHandler) (n = this.errorHandler) == null || n.onError(e, or);else throw e;
    }
    /**
    * Set basic authentication header (eg writekey)
    */
  }, {
    key: "setAuthHeader",
    value: function setAuthHeader(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var s = n ? e : nr("".concat(e, ":"));
      this.basicAuthHeader = "Basic ".concat(s);
    }
    /**
    * Clear basic authentication header
    */
  }, {
    key: "resetAuthHeader",
    value: function resetAuthHeader() {
      this.basicAuthHeader = void 0;
    }
  }]);
  return It;
}();
var Ao = new It(Qe, Q),
  G = "cookieStorage",
  B = "localStorage",
  F = "sessionStorage",
  Y = "memoryStorage",
  ie = "none",
  Oo = "test_rudder_cookie",
  Po = "test_rudder_ls",
  No = "test_rudder_ss",
  wo = "__tld__",
  Hn = "clientDataInCookie",
  jn = "clientDataInLocalStorage",
  Do = "clientDataInMemory",
  Vn = "clientDataInSessionStorage",
  Qn = ["userId", "userTraits", "anonymousId", "groupId", "groupTraits", "initialReferrer", "initialReferringDomain", "sessionInfo", "authToken"],
  de = (_de = {}, _defineProperty(_de, G, Hn), _defineProperty(_de, B, jn), _defineProperty(_de, Y, Do), _defineProperty(_de, F, Vn), _de),
  ko = function ko(t, e) {
    var n = new URL(o.lifecycle.sourceConfigUrl.value),
      s = "".concat(n.origin).concat(n.pathname, "?view=ad"),
      r = new It(t, e);
    r.setAuthHeader(o.lifecycle.writeKey.value), r.getAsyncData({
      url: s,
      options: {
        // We actually don't need the response from the request, so we are using HEAD
        method: "HEAD",
        headers: {
          "Content-Type": void 0
        }
      },
      isRawResponse: !0,
      callback: function callback(i, a) {
        var l;
        o.capabilities.isAdBlocked.value = (a == null ? void 0 : a.error) !== void 0 || ((l = a == null ? void 0 : a.xhr) == null ? void 0 : l.responseURL) !== s;
      }
    });
  },
  Lo = function Lo() {
    return !V(globalThis.crypto) && f(globalThis.crypto.getRandomValues);
  },
  qt = function qt() {
    return !V(globalThis.navigator.userAgentData);
  },
  Co = function Co() {
    return !V(globalThis.navigator.sendBeacon) && f(globalThis.navigator.sendBeacon);
  },
  Uo = function Uo() {
    return !!globalThis.navigator.userAgent.match(/Trident.*rv:11\./);
  },
  Mo = function Mo(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    var n;
    e === "none" && t(void 0), e === "default" && t(navigator.userAgentData), e === "full" && ((n = navigator.userAgentData) == null || n.getHighEntropyValues(["architecture", "bitness", "brands", "mobile", "model", "platform", "platformVersion", "uaFullVersion", "fullVersionList", "wow64"]).then(function (s) {
      t(s);
    }).catch(function () {
      t();
    }));
  },
  $o = function $o() {
    var t = globalThis.document.createElement("div");
    return t.setAttribute("data-a-b", "c"), t.dataset ? t.dataset.aB === "c" : !1;
  },
  ct = {
    // Ideally, we should separate the checks for URL and URLSearchParams but
    // the polyfill service serves them under the same feature name, "URL".
    URL: function URL() {
      return !f(globalThis.URL) || !f(globalThis.URLSearchParams);
    },
    Promise: function Promise() {
      return !f(globalThis.Promise);
    },
    "Number.isNaN": function NumberIsNaN() {
      return !f(globalThis.Number.isNaN);
    },
    "Number.isInteger": function NumberIsInteger() {
      return !f(globalThis.Number.isInteger);
    },
    "Array.from": function ArrayFrom() {
      return !f(globalThis.Array.from);
    },
    "Array.prototype.find": function ArrayPrototypeFind() {
      return !f(globalThis.Array.prototype.find);
    },
    "Array.prototype.includes": function ArrayPrototypeIncludes() {
      return !f(globalThis.Array.prototype.includes);
    },
    "String.prototype.endsWith": function StringPrototypeEndsWith() {
      return !f(globalThis.String.prototype.endsWith);
    },
    "String.prototype.startsWith": function StringPrototypeStartsWith() {
      return !f(globalThis.String.prototype.startsWith);
    },
    "String.prototype.includes": function StringPrototypeIncludes() {
      return !f(globalThis.String.prototype.includes);
    },
    "String.prototype.replaceAll": function StringPrototypeReplaceAll() {
      return !f(globalThis.String.prototype.replaceAll);
    },
    "String.fromCodePoint": function StringFromCodePoint() {
      return !f(globalThis.String.fromCodePoint);
    },
    "Object.entries": function ObjectEntries() {
      return !f(globalThis.Object.entries);
    },
    "Object.values": function ObjectValues() {
      return !f(globalThis.Object.values);
    },
    "Object.assign": function ObjectAssign() {
      return !f(globalThis.Object.assign);
    },
    "Element.prototype.dataset": function ElementPrototypeDataset() {
      return !$o();
    },
    // Ideally, we should separate the checks for TextEncoder and TextDecoder but
    // the polyfill service serves them under the same feature name, "TextEncoder".
    TextEncoder: function TextEncoder() {
      return !f(globalThis.TextEncoder) || !f(globalThis.TextDecoder);
    },
    requestAnimationFrame: function requestAnimationFrame() {
      return !f(globalThis.requestAnimationFrame) || !f(globalThis.cancelAnimationFrame);
    },
    CustomEvent: function CustomEvent() {
      return !f(globalThis.CustomEvent);
    },
    "navigator.sendBeacon": function navigatorSendBeacon() {
      return !f(globalThis.navigator.sendBeacon);
    },
    // Note, the polyfill service serves both ArrayBuffer and Uint8Array under the same feature name, "ArrayBuffer".
    ArrayBuffer: function ArrayBuffer() {
      return !f(globalThis.Uint8Array);
    }
  },
  Bo = function Bo() {
    var t = Object.keys(ct);
    var e = !1;
    for (var n = 0; n < t.length; n++) {
      var s = ct[t[n]];
      if (f(s) && s()) {
        e = !0;
        break;
      }
    }
    return e;
  },
  Wt = function Wt() {
    var t = {
      density: 0,
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0
    };
    return t = {
      width: globalThis.screen.width,
      height: globalThis.screen.height,
      density: globalThis.devicePixelRatio,
      innerWidth: globalThis.innerWidth,
      innerHeight: globalThis.innerHeight
    }, t;
  },
  Kn = function Kn(t) {
    var e = ["QuotaExceededError", "NS_ERROR_DOM_QUOTA_REACHED"],
      n = [22, 1014],
      s = e.includes(t.name) || n.includes(t.code);
    return t instanceof DOMException && s;
  },
  fe = function fe() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : B;
    var e = arguments.length > 1 ? arguments[1] : undefined;
    var n = arguments.length > 2 ? arguments[2] : undefined;
    var s, r;
    try {
      switch (t) {
        case Y:
          return !0;
        case G:
          s = e, r = Oo;
          break;
        case B:
          s = e !== null && e !== void 0 ? e : globalThis.localStorage, r = Po;
          break;
        case F:
          s = e !== null && e !== void 0 ? e : globalThis.sessionStorage, r = No;
          break;
        default:
          return !1;
      }
      return s ? (s.setItem(r, "true"), s.getItem(r) ? (s.removeItem(r), !0) : !1) : !1;
    } catch (i) {
      var a = ii(bn, t);
      var l = "unavailable";
      return Kn(i) && (l = "full"), n == null || n.warn("".concat(a).concat(l, "."), i), !1;
    }
  },
  Jt = function Jt(t, e) {
    try {
      return encodeURIComponent(t);
    } catch (n) {
      e == null || e.error(Gi, n);
      return;
    }
  },
  Zt = function Zt(t) {
    try {
      return decodeURIComponent(t);
    } catch (_unused2) {
      return;
    }
  },
  Go = function Go(t) {
    var e = {},
      n = t.split(/\s*;\s*/);
    var s;
    return n[0] && n.forEach(function (r) {
      s = r.split("=");
      var i = s[0] ? Zt(s[0]) : void 0;
      i && (e[i] = s[1] ? Zt(s[1]) : void 0);
    }), e;
  },
  xo = function xo(t, e, n, s) {
    var r = _objectSpread({}, n);
    var i = "".concat(Jt(t, s), "=").concat(Jt(e, s));
    H(e) && (r.maxage = -1), r.maxage && (r.expires = new Date(+ /* @__PURE__ */new Date() + r.maxage)), r.path && (i += "; path=".concat(r.path)), r.domain && (i += "; domain=".concat(r.domain)), r.expires && (i += "; expires=".concat(r.expires.toUTCString())), r.samesite && (i += "; samesite=".concat(r.samesite)), r.secure && (i += "; secure"), globalThis.document.cookie = i;
  },
  ut = function ut() {
    var t = globalThis.document.cookie;
    return Go(t);
  },
  Fo = function Fo(t) {
    return ut()[t];
  },
  J = function J(t, e, n, s) {
    switch (arguments.length) {
      case 4:
      case 3:
      case 2:
        return xo(t, e, n, s);
      case 1:
        return t ? Fo(t) : ut();
      default:
        return ut();
    }
  },
  Ho = function Ho(t) {
    var e = document.createElement("a");
    return e.href = t, e.hostname;
  },
  jo = function jo(t) {
    var _ref9;
    var e = typeof globalThis.URL != "function" ? Ho(t) : new URL(t).hostname,
      n = (_ref9 = e == null ? void 0 : e.split(".")) !== null && _ref9 !== void 0 ? _ref9 : [],
      s = n[n.length - 1],
      r = [];
    if (n.length === 4 && s && s === parseInt(s, 10).toString()) return r;
    if (n.length <= 1) return n[0] && n[0].indexOf("localhost") !== -1 ? ["localhost"] : r;
    for (var i = n.length - 2; i >= 0; i -= 1) r.push(n.slice(i).join("."));
    return r;
  },
  Vo = function Vo(t) {
    var e = jo(t);
    for (var n = 0; n < e.length; n += 1) {
      var s = e[n],
        r = wo,
        i = {
          domain: "".concat(s.indexOf("localhost") !== -1 ? "" : ".").concat(s)
        };
      if (J(r, 1, i), J(r)) return J(r, null, i), s;
    }
    return "";
  },
  Qo = function Qo() {
    var t = Vo(globalThis.location.href);
    return {
      maxage: pr,
      path: "/",
      domain: !t || t === "." ? void 0 : t,
      samesite: "Lax",
      enabled: !0
    };
  },
  Ko = function Ko() {
    return {
      enabled: !0
    };
  },
  zo = function zo() {
    return {
      enabled: !0
    };
  },
  Yo = function Yo() {
    return {
      enabled: !0
    };
  },
  ge = /*#__PURE__*/function () {
    function ge() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var n = arguments.length > 1 ? arguments[1] : undefined;
      _classCallCheck(this, ge);
      _(this, "isSupportAvailable", !0);
      _(this, "isEnabled", !0);
      _(this, "length", 0);
      if (ge.globalSingleton) return ge.globalSingleton;
      this.options = Qo(), this.logger = n, this.configure(e), ge.globalSingleton = this;
    }
    _createClass(ge, [{
      key: "configure",
      value: function configure(e) {
        var _this$options;
        return this.options = w((_this$options = this.options) !== null && _this$options !== void 0 ? _this$options : {}, e), e.sameDomainCookiesOnly && delete this.options.domain, this.isSupportAvailable = fe(G, this, this.logger), this.isEnabled = !!(this.options.enabled && this.isSupportAvailable), this.options;
      }
    }, {
      key: "setItem",
      value: function setItem(e, n) {
        return J(e, n, this.options, this.logger), this.length = Object.keys(J()).length, !0;
      }
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "getItem",
      value: function getItem(e) {
        var n = J(e);
        return L(n) ? null : n;
      }
    }, {
      key: "removeItem",
      value: function removeItem(e) {
        var n = this.setItem(e, null);
        return this.length = Object.keys(J()).length, n;
      }
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "key",
      value: function key(e) {
        var _this$keys$e;
        return (_this$keys$e = this.keys()[e]) !== null && _this$keys$e !== void 0 ? _this$keys$e : null;
      }
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "keys",
      value: function keys() {
        return Object.keys(J());
      }
    }]);
    return ge;
  }();
_(ge, "globalSingleton", null);
var Be = ge;
var Xo = /*#__PURE__*/function () {
  function Xo(e, n) {
    _classCallCheck(this, Xo);
    _(this, "isEnabled", !0);
    _(this, "length", 0);
    _(this, "data", {});
    this.options = Yo(), this.logger = n, this.configure(e !== null && e !== void 0 ? e : {});
  }
  _createClass(Xo, [{
    key: "configure",
    value: function configure(e) {
      return this.options = w(this.options, e), this.isEnabled = !!this.options.enabled, this.options;
    }
  }, {
    key: "setItem",
    value: function setItem(e, n) {
      return this.data[e] = n, this.length = Object.keys(this.data).length, n;
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      return e in this.data ? this.data[e] : null;
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      return e in this.data && delete this.data[e], this.length = Object.keys(this.data).length, null;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.data = {}, this.length = 0;
    }
  }, {
    key: "key",
    value: function key(e) {
      var _this$keys$e2;
      return (_this$keys$e2 = this.keys()[e]) !== null && _this$keys$e2 !== void 0 ? _this$keys$e2 : null;
    }
  }, {
    key: "keys",
    value: function keys() {
      return Object.keys(this.data);
    }
  }]);
  return Xo;
}();
var dt = new Xo({}, Q);
var qo = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? window : (typeof global === "undefined" ? "undefined" : _typeof(global)) < "u" ? global : (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" ? self : {};
function Wo(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var zn = {
  exports: {}
};
(function (t, e) {
  (function (n, s) {
    t.exports = s();
  })(qo, function () {
    function n(g) {
      return g = JSON.stringify(g), !!/^\{[\s\S]*\}$/.test(g);
    }
    function s(g) {
      return g === void 0 || typeof g == "function" ? g + "" : JSON.stringify(g);
    }
    function r(g) {
      if (typeof g == "string") try {
        return JSON.parse(g);
      } catch (_unused3) {
        return g;
      }
    }
    function i(g) {
      return {}.toString.call(g) === "[object Function]";
    }
    function a(g) {
      return Object.prototype.toString.call(g) === "[object Array]";
    }
    function l(g) {
      var h = "_Is_Incognit",
        E = "yes";
      try {
        g || (g = window.localStorage), g.setItem(h, E), g.removeItem(h);
      } catch (_unused4) {
        var v = {};
        v._data = {}, v.setItem = function (T, K) {
          return v._data[T] = String(K);
        }, v.getItem = function (T) {
          return v._data.hasOwnProperty(T) ? v._data[T] : void 0;
        }, v.removeItem = function (T) {
          return delete v._data[T];
        }, v.clear = function () {
          return v._data = {};
        }, g = v;
      } finally {
        g.getItem(h) === E && g.removeItem(h);
      }
      return g;
    }
    var c = l();
    function d() {
      if (!(this instanceof d)) return new d();
    }
    d.prototype = {
      set: function set(h, E) {
        if (h && !n(h)) c.setItem(h, s(E));else if (n(h)) for (var v in h) this.set(v, h[v]);
        return this;
      },
      get: function get(h) {
        if (h === void 0) {
          var E = {};
          return this.forEach(function (as, ls) {
            return E[as] = ls;
          }), E;
        }
        if (h.charAt(0) === "?") return this.has(h.substr(1));
        var v = arguments;
        if (v.length > 1) {
          for (var b = {}, T = 0, K = v.length; T < K; T++) {
            var Rt = r(c.getItem(v[T]));
            this.has(v[T]) && (b[v[T]] = Rt);
          }
          return b;
        }
        return r(c.getItem(h));
      },
      clear: function clear() {
        return c.clear(), this;
      },
      remove: function remove(h) {
        var E = this.get(h);
        return c.removeItem(h), E;
      },
      has: function has(h) {
        return {}.hasOwnProperty.call(this.get(), h);
      },
      keys: function keys() {
        var h = [];
        return this.forEach(function (E) {
          h.push(E);
        }), h;
      },
      forEach: function forEach(h) {
        for (var E = 0, v = c.length; E < v; E++) {
          var b = c.key(E);
          h(b, this.get(b));
        }
        return this;
      },
      search: function search(h) {
        for (var E = this.keys(), v = {}, b = 0, T = E.length; b < T; b++) E[b].indexOf(h) > -1 && (v[E[b]] = this.get(E[b]));
        return v;
      },
      len: function len() {
        return c.length;
      }
    };
    var p = null;
    function m(g, h) {
      var E = arguments,
        v = null;
      if (p || (p = d()), E.length === 0) return p.get();
      if (E.length === 1) {
        if (typeof g == "string") return p.get(g);
        if (n(g)) return p.set(g);
      }
      if (E.length === 2 && typeof g == "string") {
        if (!h) return p.remove(g);
        if (h && typeof h == "string") return p.set(g, h);
        h && i(h) && (v = null, v = h(g, p.get(g)), m.set(g, v));
      }
      if (E.length === 2 && a(g) && i(h)) for (var b = 0, T = g.length; b < T; b++) v = h(g[b], p.get(g[b])), m.set(g[b], v);
      return m;
    }
    for (var N in d.prototype) m[N] = d.prototype[N];
    return m;
  });
})(zn);
var Jo = zn.exports;
var te = /* @__PURE__ */Wo(Jo);
var Zo = /*#__PURE__*/function () {
  function Zo() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var n = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, Zo);
    _(this, "isSupportAvailable", !0);
    _(this, "isEnabled", !0);
    _(this, "length", 0);
    this.options = Ko(), this.logger = n, this.configure(e);
  }
  _createClass(Zo, [{
    key: "configure",
    value: function configure(e) {
      return this.options = w(this.options, e), this.isSupportAvailable = fe(B, this, this.logger), this.isEnabled = !!(this.options.enabled && this.isSupportAvailable), this.options;
    }
  }, {
    key: "setItem",
    value: function setItem(e, n) {
      te.set(e, n), this.length = te.len();
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getItem",
    value: function getItem(e) {
      var n = te.get(e);
      return L(n) ? null : n;
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      te.remove(e), this.length = te.len();
    }
  }, {
    key: "clear",
    value: function clear() {
      te.clear(), this.length = 0;
    }
  }, {
    key: "key",
    value: function key(e) {
      var _this$keys$e3;
      return (_this$keys$e3 = this.keys()[e]) !== null && _this$keys$e3 !== void 0 ? _this$keys$e3 : null;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "keys",
    value: function keys() {
      return te.keys();
    }
  }]);
  return Zo;
}();
var Yn = new Zo({}, Q);
var ea = /*#__PURE__*/function () {
  function ea() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var n = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, ea);
    _(this, "isSupportAvailable", !0);
    _(this, "isEnabled", !0);
    _(this, "length", 0);
    _(this, "store", globalThis.sessionStorage);
    this.options = zo(), this.logger = n, this.configure(e);
  }
  _createClass(ea, [{
    key: "configure",
    value: function configure(e) {
      return this.options = w(this.options, e), this.isSupportAvailable = fe(F, this, this.logger), this.isEnabled = !!(this.options.enabled && this.isSupportAvailable), this.options;
    }
  }, {
    key: "setItem",
    value: function setItem(e, n) {
      this.store.setItem(e, n), this.length = this.store.length;
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      var n = this.store.getItem(e);
      return L(n) ? null : n;
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      this.store.removeItem(e), this.length = this.store.length;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.store.clear(), this.length = 0;
    }
  }, {
    key: "key",
    value: function key(e) {
      return this.store.key(e);
    }
  }, {
    key: "keys",
    value: function keys() {
      var e = [];
      for (var n = 0; n < this.store.length; n += 1) {
        var s = this.store.key(n);
        s !== null && e.push(s);
      }
      return e;
    }
  }]);
  return ea;
}();
var Xn = new ea({}, Q),
  x = function x(t) {
    switch (t) {
      case B:
        return Yn;
      case F:
        return Xn;
      case Y:
        return dt;
      case G:
        return new Be({}, Q);
      default:
        return dt;
    }
  },
  ta = function ta(t) {
    new Be({}, Q).configure(t);
  },
  na = function na(t) {
    Yn.configure(t);
  },
  sa = function sa(t) {
    dt.configure(t);
  },
  ra = function ra(t) {
    Xn.configure(t);
  },
  ia = function ia() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    ta(t), na(e), sa(n), ra(s);
  };
var oa = /*#__PURE__*/function () {
  function oa(e, n, s) {
    var _e$isEncrypted, _e$validKeys, _e$errorHandler, _e$logger;
    _classCallCheck(this, oa);
    _(this, "hasErrorHandler", !1);
    this.id = e.id, this.name = e.name, this.isEncrypted = (_e$isEncrypted = e.isEncrypted) !== null && _e$isEncrypted !== void 0 ? _e$isEncrypted : !1, this.validKeys = (_e$validKeys = e.validKeys) !== null && _e$validKeys !== void 0 ? _e$validKeys : {}, this.engine = n !== null && n !== void 0 ? n : x(B), this.noKeyValidation = Object.keys(this.validKeys).length === 0, this.noCompoundKey = e.noCompoundKey, this.originalEngine = this.engine, this.errorHandler = (_e$errorHandler = e.errorHandler) !== null && _e$errorHandler !== void 0 ? _e$errorHandler : Qe, this.hasErrorHandler = !!this.errorHandler, this.logger = (_e$logger = e.logger) !== null && _e$logger !== void 0 ? _e$logger : Q, this.pluginsManager = s;
  }
  /**
  * Ensure the key is valid and with correct format
  */
  _createClass(oa, [{
    key: "createValidKey",
    value: function createValidKey(e) {
      var n = this.name,
        s = this.id,
        r = this.validKeys,
        i = this.noKeyValidation,
        a = this.noCompoundKey;
      if (i) return a ? e : [n, s, e].join(".");
      var l;
      return Object.values(r).forEach(function (c) {
        c === e && (l = a ? e : [n, s, e].join("."));
      }), l;
    }
    /**
    * Switch to inMemoryEngine, bringing any existing data with.
    */
  }, {
    key: "swapQueueStoreToInMemoryEngine",
    value: function swapQueueStoreToInMemoryEngine() {
      var _this12 = this;
      var e = this.name,
        n = this.id,
        s = this.validKeys,
        r = this.noCompoundKey,
        i = x(Y);
      Object.keys(s).forEach(function (a) {
        var l = _this12.get(s[a]),
          c = r ? a : [e, n, a].join(".");
        i.setItem(c, l), _this12.remove(a);
      }), this.engine = i;
    }
    /**
    * Set value by key.
    */
  }, {
    key: "set",
    value: function set(e, n) {
      var r;
      var s = this.createValidKey(e);
      if (s) try {
        this.engine.setItem(s, this.encrypt(He(n, !1, [], this.logger)));
      } catch (i) {
        Kn(i) ? ((r = this.logger) == null || r.warn(Oi("Store ".concat(this.id))), this.swapQueueStoreToInMemoryEngine(), this.set(e, n)) : this.onError(_e(i, hi(e)));
      }
    }
    /**
    * Get by Key.
    */
  }, {
    key: "get",
    value: function get(e) {
      var n = this.createValidKey(e);
      try {
        if (!n) return null;
        var s = this.decrypt(this.engine.getItem(n));
        return V(s) ? null : JSON.parse(s);
      } catch (s) {
        return this.onError(new Error("".concat(fi(e), ": ").concat(s.message))), null;
      }
    }
    /**
    * Remove by Key.
    */
  }, {
    key: "remove",
    value: function remove(e) {
      var n = this.createValidKey(e);
      n && this.engine.removeItem(n);
    }
    /**
    * Get original engine
    */
  }, {
    key: "getOriginalEngine",
    value: function getOriginalEngine() {
      return this.originalEngine;
    }
    /**
    * Decrypt values
    */
  }, {
    key: "decrypt",
    value: function decrypt(e) {
      return V(e) ? null : this.crypto(e, "decrypt");
    }
    /**
    * Encrypt value
    */
  }, {
    key: "encrypt",
    value: function encrypt(e) {
      return this.crypto(e, "encrypt");
    }
    /**
    * Extension point to use with encryption plugins
    */
  }, {
    key: "crypto",
    value: function crypto(e, n) {
      if (!this.isEncrypted || !e || typeof e != "string" || Zs(e) === "") return e;
      var r = "storage.".concat(n),
        i = this.pluginsManager ? this.pluginsManager.invokeSingle(r, e) : e;
      return _typeof(i) > "u" ? e : i !== null && i !== void 0 ? i : "";
    }
    /**
    * Handle errors
    */
  }, {
    key: "onError",
    value: function onError(e) {
      var n;
      if (this.hasErrorHandler) (n = this.errorHandler) == null || n.onError(e, "Store ".concat(this.id));else throw e;
    }
  }]);
  return oa;
}();
var aa = function aa(t, e) {
  var s;
  var n;
  if (t.consents.preConsent.value.enabled) switch ((s = t.consents.preConsent.value.storage) == null ? void 0 : s.strategy) {
    case "none":
      n = ie;
      break;
    case "session":
      e !== "sessionInfo" && (n = ie);
      break;
    case "anonymousId":
      e !== "anonymousId" && (n = ie);
      break;
  }
  return n;
};
var la = /*#__PURE__*/function () {
  function la(e, n, s) {
    _classCallCheck(this, la);
    _(this, "stores", {});
    _(this, "isInitialized", !1);
    _(this, "hasErrorHandler", !1);
    this.errorHandler = n, this.logger = s, this.hasErrorHandler = !!this.errorHandler, this.pluginsManager = e, this.onError = this.onError.bind(this);
  }
  /**
  * Configure available storage client instances
  */
  _createClass(la, [{
    key: "init",
    value: function init() {
      var _n$cookieStorageOptio, _ref10;
      var s;
      if (this.isInitialized) return;
      var e = o.loadOptions.value,
        n = {
          cookieStorageOptions: {
            samesite: e.sameSiteCookie,
            secure: e.secureCookie,
            domain: e.setCookieDomain,
            sameDomainCookiesOnly: e.sameDomainCookiesOnly,
            enabled: !0
          },
          localStorageOptions: {
            enabled: !0
          },
          inMemoryStorageOptions: {
            enabled: !0
          },
          sessionStorageOptions: {
            enabled: !0
          }
        };
      ia(ve(w((_n$cookieStorageOptio = n.cookieStorageOptions) !== null && _n$cookieStorageOptio !== void 0 ? _n$cookieStorageOptio : {}, (_ref10 = (s = o.storage.cookie) == null ? void 0 : s.value) !== null && _ref10 !== void 0 ? _ref10 : {})), ve(n.localStorageOptions), ve(n.inMemoryStorageOptions), ve(n.sessionStorageOptions)), this.initClientDataStores(), this.isInitialized = !0;
    }
    /**
    * Create store to persist data used by the SDK like session, used details etc
    */
  }, {
    key: "initClientDataStores",
    value: function initClientDataStores() {
      var _this13 = this;
      this.initializeStorageState(), [Y, B, G, F].forEach(function (n) {
        var s;
        (s = x(n)) != null && s.isEnabled && _this13.setStore({
          id: de[n],
          name: de[n],
          isEncrypted: !0,
          noCompoundKey: !0,
          type: n
        });
      });
    }
  }, {
    key: "initializeStorageState",
    value: function initializeStorageState() {
      var _this14 = this;
      var a;
      var e = o.storage.type.value,
        n = (a = o.loadOptions.value.storage) == null ? void 0 : a.entries;
      var s = o.consents.postConsent.value.storage;
      (A(s == null ? void 0 : s.type) || A(s == null ? void 0 : s.entries)) && (e = s == null ? void 0 : s.type, n = s == null ? void 0 : s.entries);
      var r = !0,
        i = {};
      Qn.forEach(function (l) {
        var _ref11, _ref12, _aa;
        var h;
        var c = l,
          d = l,
          p = (h = n == null ? void 0 : n[c]) == null ? void 0 : h.type,
          N = (_ref11 = (_ref12 = (_aa = aa(o, l)) !== null && _aa !== void 0 ? _aa : p) !== null && _ref12 !== void 0 ? _ref12 : e) !== null && _ref11 !== void 0 ? _ref11 : it,
          g = _this14.getResolvedStorageTypeForEntry(N, l);
        g !== ie && (r = !1), i = _objectSpread(_objectSpread({}, i), {}, _defineProperty({}, l, {
          type: g,
          key: ue[d]
        }));
      }), M(function () {
        o.storage.type.value = e, o.storage.entries.value = i, o.storage.trulyAnonymousTracking.value = r;
      });
    }
  }, {
    key: "getResolvedStorageTypeForEntry",
    value: function getResolvedStorageTypeForEntry(e, n) {
      var r, i, a, l, c, d;
      var s = e;
      switch (e) {
        case B:
          (r = x(B)) != null && r.isEnabled || (s = Y);
          break;
        case F:
          (i = x(F)) != null && i.isEnabled || (s = Y);
          break;
        case Y:
        case ie:
          break;
        case G:
        default:
          (a = x(G)) != null && a.isEnabled ? s = G : (l = x(B)) != null && l.isEnabled ? s = B : (c = x(F)) != null && c.isEnabled ? s = F : s = Y;
          break;
      }
      return s !== e && ((d = this.logger) == null || d.warn(Pi(kt, n, e, s))), s;
    }
    /**
    * Create a new store
    */
  }, {
    key: "setStore",
    value: function setStore(e) {
      var n = x(e.type);
      return this.stores[e.id] = new oa(e, n, this.pluginsManager), this.stores[e.id];
    }
    /**
    * Retrieve a store
    */
  }, {
    key: "getStore",
    value: function getStore(e) {
      return this.stores[e];
    }
    /**
    * Handle errors
    */
  }, {
    key: "onError",
    value: function onError(e) {
      var n;
      if (this.hasErrorHandler) (n = this.errorHandler) == null || n.onError(e, kt);else throw e;
    }
  }]);
  return la;
}();
var oe = function oe(t) {
    return t && t.endsWith("/") ? oe(t.substring(0, t.length - 1)) : t;
  },
  Ke = function Ke(t) {
    try {
      return !!new URL(t);
    } catch (_unused5) {
      return !1;
    }
  },
  qn = function qn(t) {
    var e = "";
    try {
      e = new URL(t).host;
    } catch (_unused6) {}
    return e;
  },
  ca = function ca(t) {
    var e = {};
    try {
      var n = new URL(t),
        s = "utm_";
      n.searchParams.forEach(function (r, i) {
        if (i.startsWith(s)) {
          var a = i.substring(s.length);
          a === "campaign" && (a = "name"), e[a] = r;
        }
      });
    } catch (_unused7) {}
    return e;
  },
  ua = function ua(t) {
    var e = t;
    try {
      var n = new URL(t);
      e = n.origin + n.pathname + n.search;
    } catch (_unused8) {}
    return e;
  },
  da = function da(t) {
    if (!k(t) || t.trim().length === 0) throw new Error(ai(t));
  },
  ga = function ga(t) {
    if (t && !Ke(t)) throw new Error(li(t));
  },
  ha = function ha(t, e) {
    da(t), ga(e);
  },
  fa = function fa(t) {
    return y(t) && y(t.source) && !V(t.source.id) && y(t.source.config) && Array.isArray(t.source.destinations);
  },
  pa = function pa(t) {
    return typeof t == "string" && kn.includes(t);
  },
  va = function va(t) {
    return t.replace(/\/{2,}/g, "/");
  },
  Ea = ["BeaconQueue", "Bugsnag", "CustomConsentManager", "DeviceModeDestinations", "DeviceModeTransformation", "ErrorReporting", "ExternalAnonymousId", "GoogleLinker", "KetchConsentManager", "NativeDestinationQueue", "OneTrustConsentManager", "StorageEncryption", "StorageEncryptionLegacy", "StorageMigrator", "XhrQueue"],
  Wn = function Wn(t) {
    return typeof t == "number" && !Number.isNaN(t);
  },
  ma = function ma(t, e) {
    return e.toString().length >= t;
  },
  Jn = function Jn(t) {
    return Wn(t) && t >= 0 && Number.isInteger(t);
  },
  ya = function ya(t, e) {
    var _n$plugins;
    var a, l, c, d;
    var n = I(e);
    return k(n.setCookieDomain) || delete n.setCookieDomain, ["Strict", "Lax", "None"].includes(n.sameSiteCookie) || delete n.sameSiteCookie, n.secureCookie = n.secureCookie === !0, ["none", "default", "full"].includes(n.uaChTrackLevel) || delete n.uaChTrackLevel, y(n.integrations) || delete n.integrations, n.plugins = (_n$plugins = n.plugins) !== null && _n$plugins !== void 0 ? _n$plugins : Ea, n.useGlobalIntegrationsConfigInEvents = n.useGlobalIntegrationsConfigInEvents === !0, n.bufferDataPlaneEventsUntilReady = n.bufferDataPlaneEventsUntilReady === !0, n.sendAdblockPage = n.sendAdblockPage === !0, y(n.sendAdblockPageOptions) || delete n.sendAdblockPageOptions, A(n.loadIntegration) ? n.loadIntegration = n.loadIntegration === !0 : delete n.loadIntegration, y(n.storage) ? (n.storage = ne(n.storage), n.storage.migrate = ((a = n.storage) == null ? void 0 : a.migrate) === !0) : delete n.storage, y(n.beaconQueueOptions) ? n.beaconQueueOptions = ne(n.beaconQueueOptions) : delete n.beaconQueueOptions, y(n.destinationsQueueOptions) ? n.destinationsQueueOptions = ne(n.destinationsQueueOptions) : delete n.destinationsQueueOptions, y(n.queueOptions) ? n.queueOptions = ne(n.queueOptions) : delete n.queueOptions, n.lockIntegrationsVersion = n.lockIntegrationsVersion === !0, Wn(n.dataPlaneEventsBufferTimeout) || delete n.dataPlaneEventsBufferTimeout, y((l = n.storage) == null ? void 0 : l.cookie) ? n.storage.cookie = ne((d = n.storage) == null ? void 0 : d.cookie) : (c = n.storage) == null || delete c.cookie, y(n.preConsent) ? n.preConsent = ne(n.preConsent) : delete n.preConsent, w(t, n);
  },
  Sa = function Sa(t, e, n, s) {
    var r = new URLSearchParams({
      p: lr,
      v: Me,
      build: St,
      writeKey: e,
      lockIntegrationsVersion: n.toString()
    });
    var i = Bn,
      a = r,
      l = "/sourceConfig/",
      c = "";
    if (t) try {
      var d = new URL(t);
      oe(d.pathname).endsWith("/sourceConfig") || (d.pathname = "".concat(oe(d.pathname), "/sourceConfig/")), d.pathname = va(d.pathname), r.forEach(function (p, m) {
        d.searchParams.get(m) === null && d.searchParams.set(m, p);
      }), i = d.origin, l = d.pathname, a = d.searchParams, c = d.hash;
    } catch (_unused9) {
      s == null || s.warn($i(j, t));
    }
    return "".concat(i).concat(l, "?").concat(a).concat(c);
  },
  _a = function _a(t) {
    var e = [];
    return t.forEach(function (n) {
      n.enabled && !n.deleted && e.push({
        id: n.id,
        displayName: n.destinationDefinition.displayName,
        config: n.config,
        shouldApplyDeviceModeTransformation: n.shouldApplyDeviceModeTransformation || !1,
        propagateEventsUntransformedOnError: n.propagateEventsUntransformedOnError || !1,
        userFriendlyId: "".concat(n.destinationDefinition.displayName.replaceAll(" ", "-"), "___").concat(n.id)
      });
    }), e;
  },
  gt = "US",
  Ia = function Ia(t) {
    var e;
    if (Array.isArray(t) && t.length > 0) {
      var n = t.find(function (s) {
        return s.default === !0;
      });
      if (n && Ke(n.url)) return n.url;
    }
    return e;
  },
  ba = function ba(t, e) {
    if (t && !["US", "EU"].includes(t)) {
      e == null || e.warn(yi(j, t, gt));
      return;
    }
    return t;
  },
  Ta = function Ta(t, e, n, s) {
    if (t && Object.keys(t).length > 0) {
      var _ba;
      var r = (_ba = ba(n, s)) !== null && _ba !== void 0 ? _ba : gt,
        i = t[r] || t[gt],
        a = Ia(i);
      if (a) return a;
    }
    if (e) return e;
  },
  Ra = function Ra() {
    return !!(window.chrome && window.chrome.runtime && window.chrome.runtime.id);
  },
  We = "none",
  Je = "immediate",
  Aa = function Aa(t) {
    var e, n;
    return ((n = (e = t == null ? void 0 : t.statsCollection) == null ? void 0 : e.errors) == null ? void 0 : n.enabled) === !0;
  },
  Oa = function Oa(t) {
    var e, n;
    return (n = (e = t == null ? void 0 : t.statsCollection) == null ? void 0 : e.errors) == null ? void 0 : n.provider;
  },
  Pa = function Pa(t) {
    var e, n;
    return ((n = (e = t == null ? void 0 : t.statsCollection) == null ? void 0 : e.metrics) == null ? void 0 : n.enabled) === !0;
  },
  ze = {
    All: !0
  },
  Na = function Na(t) {
    var e = {
      sendPageEvent: !1,
      trackConsent: !1,
      discardPreConsentEvents: !1
    };
    if (y(t)) {
      var n = I(t);
      e.storage = n.storage, A(n.integrations) && (e.integrations = y(n.integrations) ? n.integrations : ze), e.discardPreConsentEvents = n.discardPreConsentEvents === !0, e.sendPageEvent = n.sendPageEvent === !0, e.trackConsent = n.trackConsent === !0, xe(n.consentManagement) && (e.consentManagement = w(n.consentManagement, {
        enabled: o.consents.enabled.value
      }));
    }
    return e;
  },
  en = function en(t) {
    return xe(t) || Array.isArray(t);
  },
  wa = function wa(t, e) {
    var n = t.provider;
    var s = n ? at[n] : void 0;
    return n && !s && (e == null || e.error(qr(j, n, at)), n = void 0), {
      provider: n,
      consentManagerPluginName: s
    };
  },
  Zn = function Zn(t, e) {
    var _wa;
    var n,
      s = [],
      r = [],
      i = !1,
      a,
      l = (t == null ? void 0 : t.enabled) === !0;
    xe(t) && l && ((_wa = wa(t, e), a = _wa.provider, n = _wa.consentManagerPluginName), en(t.allowedConsentIds) && (s = t.allowedConsentIds, i = !0), en(t.deniedConsentIds) && (r = t.deniedConsentIds, i = !0));
    var c = {
      allowedConsentIds: s,
      deniedConsentIds: r
    };
    return l = l && !!n, {
      provider: a,
      consentManagerPluginName: n,
      initialized: i,
      enabled: l,
      consentsData: c
    };
  },
  es = function es() {
    var t = document.getElementsByTagName("script");
    var e;
    return Array.prototype.slice.call(t).some(function (s) {
      var r = oe(s.getAttribute("src"));
      return r && r.match(/^.*rsa?(\.min)?\.js$/) ? (e = r, !0) : !1;
    }), e;
  },
  Da = function Da(t, e) {
    if (o.reporting.isErrorReportingEnabled.value = Aa(t.source.config) && !Ra(), o.reporting.isMetricsReportingEnabled.value = Pa(t.source.config), o.reporting.isErrorReportingEnabled.value) {
      var n = Oa(t.source.config),
        s = n ? Ne[n] : void 0;
      !L(n) && !s && (e == null || e.warn(vi(j, n, Ne, ot))), o.reporting.errorReportingProviderPluginName.value = s !== null && s !== void 0 ? s : Ne[ot];
    }
  },
  ka = function ka(t) {
    var l;
    var e = o.loadOptions.value.storage;
    var n = e == null ? void 0 : e.type;
    A(n) && !pa(n) && (t == null || t.warn(pi(j, n, it)), n = it);
    var s = (l = e == null ? void 0 : e.encryption) == null ? void 0 : l.version;
    var r = s && we[s];
    !L(s) && L(r) ? (t == null || t.warn(Ei(j, s, we, se)), s = se) : L(s) && (s = se);
    var i = e == null ? void 0 : e.migrate,
      a = i && s === se;
    i === !0 && a !== i && (t == null || t.warn(mi(j, s, se))), M(function () {
      o.storage.type.value = n, o.storage.cookie.value = e == null ? void 0 : e.cookie, o.storage.encryptionPluginName.value = we[s], o.storage.migrate.value = a;
    });
  },
  La = function La(t) {
    var _ref13, _ref14;
    var m, N, g, h;
    var _Zn = Zn(o.loadOptions.value.consentManagement, t),
      e = _Zn.provider,
      n = _Zn.consentManagerPluginName,
      s = _Zn.initialized,
      r = _Zn.enabled,
      i = _Zn.consentsData,
      a = o.loadOptions.value.preConsent;
    var l = (_ref13 = (m = a == null ? void 0 : a.storage) == null ? void 0 : m.strategy) !== null && _ref13 !== void 0 ? _ref13 : We;
    var c = ["none", "session", "anonymousId"];
    A(l) && !c.includes(l) && (l = We, t == null || t.warn(xi(j, (N = a == null ? void 0 : a.storage) == null ? void 0 : N.strategy, We)));
    var d = (_ref14 = (g = a == null ? void 0 : a.events) == null ? void 0 : g.delivery) !== null && _ref14 !== void 0 ? _ref14 : Je;
    var p = ["immediate", "buffer"];
    A(d) && !p.includes(d) && (d = Je, t == null || t.warn(Fi(j, (h = a == null ? void 0 : a.events) == null ? void 0 : h.delivery, Je))), M(function () {
      var E;
      o.consents.activeConsentManagerPluginName.value = n, o.consents.initialized.value = s, o.consents.enabled.value = r, o.consents.data.value = i, o.consents.provider.value = e, o.consents.preConsent.value = {
        // Only enable pre-consent if it is explicitly enabled and
        // if it is not already initialized and
        // if consent management is enabled
        enabled: ((E = o.loadOptions.value.preConsent) == null ? void 0 : E.enabled) === !0 && s === !1 && r === !0,
        storage: {
          strategy: l
        },
        events: {
          delivery: d
        }
      };
    });
  },
  Ca = function Ca(t) {
    var _ref15;
    var s;
    var e = o.consents.resolutionStrategy.value,
      n;
    y(t.consentManagementMetadata) && (o.consents.provider.value && (e = (_ref15 = (s = t.consentManagementMetadata.providers.find(function (r) {
      return r.provider === o.consents.provider.value;
    })) == null ? void 0 : s.resolutionStrategy) !== null && _ref15 !== void 0 ? _ref15 : o.consents.resolutionStrategy.value), n = t.consentManagementMetadata), o.consents.provider.value === "custom" && (e = void 0), M(function () {
      o.consents.metadata.value = I(n), o.consents.resolutionStrategy.value = e;
    });
  },
  Ua = function Ua(t) {
    if (o.dataPlaneEvents.deliveryEnabled.value) {
      var _e2 = "XhrQueue";
      var n = _e2;
      o.loadOptions.value.useBeacon && (o.capabilities.isBeaconAvailable.value ? n = "BeaconQueue" : (n = _e2, t == null || t.warn(Ii(j)))), M(function () {
        o.dataPlaneEvents.eventsQueuePluginName.value = n;
      });
    }
  },
  Ma = function Ma(t, e, n) {
    var s = "";
    if (n) {
      if (s = oe(n), !s || s && !Ke(s)) throw new Error(jr);
      return s;
    }
    var r = es();
    return s = r && k(r) ? r.split("/").slice(0, -1).concat(Ln).join("/") : Mn, e && (s = s.replace(_t, t)), s;
  },
  $a = function $a(t) {
    var e = "";
    if (t) {
      if (e = oe(t), !e || e && !Ke(e)) throw new Error(Vr);
      return e;
    }
    var n = es();
    return e = n && k(n) ? n.split("/").slice(0, -1).concat(Cn).join("/") : $n, e;
  };
var Ba = /*#__PURE__*/function () {
  function Ba(e, n, s) {
    _classCallCheck(this, Ba);
    _(this, "hasErrorHandler", !1);
    this.errorHandler = n, this.logger = s, this.httpClient = e, this.hasErrorHandler = !!this.errorHandler, this.onError = this.onError.bind(this), this.processConfig = this.processConfig.bind(this);
  }
  _createClass(Ba, [{
    key: "attachEffects",
    value: function attachEffects() {
      var _this15 = this;
      W(function () {
        var e;
        (e = _this15.logger) == null || e.setMinLogLevel(o.lifecycle.logLevel.value);
      });
    }
    /**
    * A function to validate, construct and store loadOption, lifecycle, source and destination
    * config related information in global state
    */
  }, {
    key: "init",
    value: function init() {
      var _this16 = this;
      this.attachEffects(), ha(o.lifecycle.writeKey.value, o.lifecycle.dataPlaneUrl.value);
      var e = o.loadOptions.value.lockIntegrationsVersion,
        n = Ma(Me, e, o.loadOptions.value.destSDKBaseURL),
        s = $a(o.loadOptions.value.pluginsSDKBaseURL);
      ka(this.logger), La(this.logger), Ua(this.logger), M(function () {
        o.lifecycle.integrationsCDNPath.value = n, o.lifecycle.pluginsCDNPath.value = s, o.loadOptions.value.logLevel && (o.lifecycle.logLevel.value = o.loadOptions.value.logLevel), o.lifecycle.sourceConfigUrl.value = Sa(o.loadOptions.value.configUrl, o.lifecycle.writeKey.value, e, _this16.logger);
      }), this.getConfig();
    }
    /**
    * Handle errors
    */
  }, {
    key: "onError",
    value: function onError(e, n, s) {
      var r;
      if (this.hasErrorHandler) (r = this.errorHandler) == null || r.onError(e, j, n, s);else throw e;
    }
    /**
    * A callback function that is executed once we fetch the source config response.
    * Use to construct and store information that are dependent on the sourceConfig.
    */
  }, {
    key: "processConfig",
    value: function processConfig(e, n) {
      if (!e) {
        this.onError(oi(n == null ? void 0 : n.error));
        return;
      }
      var s;
      try {
        k(e) ? s = JSON.parse(e) : s = e;
      } catch (a) {
        this.onError(a, jt, !0);
        return;
      }
      if (!fa(s)) {
        this.onError(new Error(jt), void 0, !0);
        return;
      }
      Da(s, this.logger);
      var r = Ta(s.source.dataplanes, o.lifecycle.dataPlaneUrl.value, o.loadOptions.value.residencyServer, this.logger);
      if (!r) {
        this.onError(new Error(Qr), void 0, !0);
        return;
      }
      var i = s.source.destinations.length > 0 ? _a(s.source.destinations) : [];
      M(function () {
        var _o$loadOptions$value$;
        o.source.value = {
          config: s.source.config,
          id: s.source.id
        }, o.nativeDestinations.configuredDestinations.value = i, o.plugins.pluginsToLoadFromConfig.value = (_o$loadOptions$value$ = o.loadOptions.value.plugins) !== null && _o$loadOptions$value$ !== void 0 ? _o$loadOptions$value$ : [], Ca(s), o.lifecycle.activeDataplaneUrl.value = oe(r), o.lifecycle.status.value = "configured";
      });
    }
    /**
    * A function to fetch source config either from /sourceConfig endpoint
    * or from getSourceConfig load option
    * @returns
    */
  }, {
    key: "getConfig",
    value: function getConfig() {
      var _this17 = this;
      var e = o.loadOptions.value.getSourceConfig;
      if (e) {
        if (!f(e)) throw new Error(Hr);
        var n = e();
        n instanceof Promise ? n.then(function (s) {
          return _this17.processConfig(s);
        }).catch(function (s) {
          _this17.onError(s, "SourceConfig");
        }) : this.processConfig(n);
      } else this.httpClient.getAsyncData({
        url: o.lifecycle.sourceConfigUrl.value,
        options: {
          headers: {
            "Content-Type": void 0
          }
        },
        callback: this.processConfig
      });
    }
  }]);
  return Ba;
}();
var Ga = function Ga() {
    var t = ( /* @__PURE__ */new Date()).toString().match(/([A-Z]+[+-]\d+)/);
    return t && t[1] ? t[1] : "NA";
  },
  ts = function ts() {
    return (document == null ? void 0 : document.referrer) || "$direct";
  },
  xa = function xa() {
    var t = document.getElementsByTagName("link");
    var e = "";
    for (var n = 0; t[n]; n += 1) {
      var s = t[n];
      if (s.getAttribute("rel") === "canonical" && !e) {
        var _s$getAttribute;
        e = (_s$getAttribute = s.getAttribute("href")) !== null && _s$getAttribute !== void 0 ? _s$getAttribute : "";
        break;
      }
    }
    return e;
  },
  Fa = function Fa() {
    if (L(globalThis.navigator)) return null;
    var t = globalThis.navigator.userAgent;
    var e = globalThis.navigator.brave;
    if (e && Object.getPrototypeOf(e).isBrave) {
      var n = t.match(/(chrome)\/([\w.]+)/i);
      n && (t = "".concat(t, " Brave/").concat(n[2]));
    }
    return t;
  },
  Ha = function Ha() {
    var _globalThis$navigator;
    return L(globalThis.navigator) ? null : (_globalThis$navigator = globalThis.navigator.language) !== null && _globalThis$navigator !== void 0 ? _globalThis$navigator : globalThis.navigator.browserLanguage;
  },
  ns = function ns() {
    var t = xa();
    var e = globalThis.location.pathname;
    var n = globalThis.location.href;
    var s = n;
    var r = globalThis.location.search;
    if (t) try {
      var c = new URL(t);
      c.search === "" ? s = t + r : s = t, e = c.pathname;
    } catch (_unused10) {}
    var i = ua(s),
      _document = document,
      a = _document.title,
      l = ts();
    return {
      path: e,
      referrer: l,
      referring_domain: qn(l),
      search: r,
      title: a,
      url: i,
      tab_url: n
    };
  },
  ja = "https://polyfill-fastly.io/v3/polyfill.min.js?version=3.111.0&features=".concat(Object.keys(ct).join("%2C")),
  Va = 10 * 1e3,
  tn = "rudderstackPolyfill";
var Qa = /*#__PURE__*/function () {
  function Qa(e, n) {
    _classCallCheck(this, Qa);
    this.logger = n, this.errorHandler = e, this.externalSrcLoader = new Rn(this.errorHandler, this.logger), this.onError = this.onError.bind(this), this.onReady = this.onReady.bind(this);
  }
  _createClass(Qa, [{
    key: "init",
    value: function init() {
      try {
        this.prepareBrowserCapabilities(), this.attachWindowListeners();
      } catch (e) {
        this.onError(e);
      }
    }
    /**
    * Detect supported capabilities and set values in state
    */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "detectBrowserCapabilities",
    value: function detectBrowserCapabilities() {
      var _this18 = this;
      M(function () {
        o.capabilities.storage.isCookieStorageAvailable.value = fe(G, x(G), _this18.logger), o.capabilities.storage.isLocalStorageAvailable.value = fe(B, void 0, _this18.logger), o.capabilities.storage.isSessionStorageAvailable.value = fe(F, void 0, _this18.logger), o.capabilities.isBeaconAvailable.value = Co(), o.capabilities.isUaCHAvailable.value = qt(), o.capabilities.isCryptoAvailable.value = Lo(), o.capabilities.isIE11.value = Uo(), o.capabilities.isOnline.value = globalThis.navigator.onLine, o.context.userAgent.value = Fa(), o.context.locale.value = Ha(), o.context.screen.value = Wt(), o.context.timezone.value = Ga(), qt() && Mo(function (e) {
          o.context["ua-ch"].value = e;
        }, o.loadOptions.value.uaChTrackLevel);
      }), W(function () {
        o.loadOptions.value.sendAdblockPage === !0 && o.lifecycle.sourceConfigUrl.value !== void 0 && ko(_this18.errorHandler, _this18.logger);
      });
    }
    /**
    * Detect if polyfills are required and then load script from polyfill URL
    */
  }, {
    key: "prepareBrowserCapabilities",
    value: function prepareBrowserCapabilities() {
      var _o$loadOptions$value$2,
        _this19 = this;
      var s;
      o.capabilities.isLegacyDOM.value = Bo();
      var e = (_o$loadOptions$value$2 = o.loadOptions.value.polyfillURL) !== null && _o$loadOptions$value$2 !== void 0 ? _o$loadOptions$value$2 : ja;
      if (o.loadOptions.value.polyfillIfRequired && o.capabilities.isLegacyDOM.value && !!e) {
        var r = e !== o.loadOptions.value.polyfillURL;
        if (r) {
          var i = "RS_polyfillCallback_".concat(o.lifecycle.writeKey.value),
            a = function a() {
              _this19.onReady(), delete globalThis[i];
            };
          globalThis[i] = a, e = "".concat(e, "&callback=").concat(i);
        }
        (s = this.externalSrcLoader) == null || s.loadJSFile({
          url: e,
          id: tn,
          async: !0,
          timeout: Va,
          callback: function callback(i) {
            i ? r || _this19.onReady() : _this19.onError(new Error(Bi(tn, e)));
          }
        });
      } else this.onReady();
    }
    /**
    * Attach listeners to window to observe event that update capabilities state values
    */
  }, {
    key: "attachWindowListeners",
    value: function attachWindowListeners() {
      globalThis.addEventListener("offline", function () {
        o.capabilities.isOnline.value = !1;
      }), globalThis.addEventListener("online", function () {
        o.capabilities.isOnline.value = !0;
      }), globalThis.addEventListener("resize", yr(function () {
        o.context.screen.value = Wt();
      }, this));
    }
    /**
    * Set the lifecycle status to next phase
    */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "onReady",
    value: function onReady() {
      this.detectBrowserCapabilities(), o.lifecycle.status.value = "browserCapabilitiesReady";
    }
    /**
    * Handles error
    * @param error The error object
    */
  }, {
    key: "onError",
    value: function onError(e) {
      if (this.errorHandler) this.errorHandler.onError(e, bn);else throw e;
    }
  }]);
  return Qa;
}();
function Ka(t) {
  return crypto.getRandomValues(new Uint8Array(t));
}
var nn = 4096,
  ke = [],
  Z = 0,
  Ze;
for (; Z < 256; Z++) ke[Z] = (Z + 256).toString(16).substring(1);
function za() {
  (!Ze || Z + 16 > nn) && (Ze = Ka(nn), Z = 0);
  for (var t = 0, e, n = ""; t < 16; t++) e = Ze[Z + t], t == 6 ? n += ke[e & 15 | 64] : t == 8 ? n += ke[e & 63 | 128] : n += ke[e], t & 1 && t > 1 && t < 11 && (n += "-");
  return Z += 16, n;
}
var re = 256,
  Le = [],
  Pe;
for (; re--;) Le[re] = (re + 256).toString(16).substring(1);
function Ya() {
  var t = 0,
    e,
    n = "";
  if (!Pe || re + 16 > 256) {
    for (Pe = Array(t = 256); t--;) Pe[t] = 256 * Math.random() | 0;
    t = re = 0;
  }
  for (; t < 16; t++) e = Pe[re + t], t == 6 ? n += Le[e & 15 | 64] : t == 8 ? n += Le[e & 63 | 128] : n += Le[e], t & 1 && t > 1 && t < 11 && (n += "-");
  return re++, n;
}
var Xa = function Xa() {
    return !V(globalThis.crypto) && f(globalThis.crypto.getRandomValues);
  },
  ss = function ss() {
    return Xa() ? za() : Ya();
  },
  qa = function qa() {
    return ( /* @__PURE__ */new Date()).toISOString();
  },
  Wa = "web",
  Ja = ["integrations", "anonymousId", "originalTimestamp"],
  sn = ["library", "consentManagement", "userAgent", "ua-ch", "screen"],
  et = ["id", "anonymous_id", "user_id", "sent_at", "timestamp", "received_at", "original_timestamp", "event", "event_text", "channel", "context_ip", "context_request_ip", "context_passed_ip", "group_id", "previous_id"],
  rn = 10,
  on = function on(t) {
    var e = Date.now();
    return !t || e > t;
  },
  Za = function Za() {
    return Date.now();
  },
  el = function el(t, e) {
    return !t || !Jn(t) || !ma(rn, t) ? (e == null || e.warn(Ai(Ee, t, rn)), !1) : !0;
  },
  tl = function tl(t) {
    var e = Date.now(),
      n = t || Se;
    return {
      id: e,
      // set the current timestamp
      expiresAt: e + n,
      // set the expiry time of the session
      timeout: n,
      sessionStart: void 0,
      autoTrack: !0
    };
  },
  nl = function nl(t, e) {
    return {
      id: el(t, e) ? t : Za(),
      sessionStart: void 0,
      manualTrack: !0
    };
  },
  me = function me(t) {
    return t === G || t === B || t === F || t === Y;
  },
  ht = function ht() {
    return ss();
  },
  sl = function sl(t) {
    var e = ns(),
      n = {};
    return Object.keys(e).forEach(function (s) {
      n[s] = (t == null ? void 0 : t[s]) || e[s];
    }), n.initial_referrer = (t == null ? void 0 : t.initial_referrer) || o.session.initialReferrer.value, n.initial_referring_domain = (t == null ? void 0 : t.initial_referring_domain) || o.session.initialReferringDomain.value, n;
  },
  rl = function rl(t, e) {
    var n = (e == null ? void 0 : e.page) || {},
      s = t,
      r = ns();
    return Object.keys(r).forEach(function (i) {
      L(s[i]) && (s[i] = n[i] || r[i]);
    }), L(s.initial_referrer) && (s.initial_referrer = n.initial_referrer || o.session.initialReferrer.value), L(s.initial_referring_domain) && (s.initial_referring_domain = n.initial_referring_domain || o.session.initialReferringDomain.value), s;
  },
  tt = function tt(t, e, n) {
    y(t) && Object.keys(t).forEach(function (s) {
      (et.includes(s) || et.includes(s.toLowerCase())) && (n == null || n.warn(Si(mt, s, e, et)));
    });
  },
  il = function il(t, e) {
    var n = t.properties,
      s = t.traits,
      r = t.context,
      i = r.traits;
    tt(n, "properties", e), tt(s, "traits", e), tt(i, "context.traits", e);
  },
  ol = function ol(t, e) {
    e.anonymousId && k(e.anonymousId) && (t.anonymousId = e.anonymousId), y(e.integrations) && (t.integrations = e.integrations), e.originalTimestamp && k(e.originalTimestamp) && (t.originalTimestamp = e.originalTimestamp);
  },
  al = function al(t, e, n) {
    var s = t;
    return Object.keys(e).forEach(function (r) {
      if (!Ja.includes(r) && !sn.includes(r)) if (r !== "context") s = w(s, _defineProperty({}, r, e[r]));else if (!L(e[r]) && y(e[r])) {
        var i = {};
        Object.keys(e[r]).forEach(function (a) {
          sn.includes(a) || (i[a] = e[r][a]);
        }), s = w(s, _objectSpread({}, i));
      } else n == null || n.warn(_i(mt));
    }), s;
  },
  ll = function ll() {
    var t;
    return o.loadOptions.value.useGlobalIntegrationsConfigInEvents && (y((t = o.consents.postConsent.value) == null ? void 0 : t.integrations) || y(o.nativeDestinations.loadOnlyIntegrations.value));
  },
  cl = function cl(t, e) {
    y(e) && (ol(t, e), t.context = al(t.context, e));
  },
  ul = function ul(t) {
    var _ref16;
    var n;
    var e;
    return ll() ? e = I((_ref16 = (n = o.consents.postConsent.value) == null ? void 0 : n.integrations) !== null && _ref16 !== void 0 ? _ref16 : o.nativeDestinations.loadOnlyIntegrations.value) : y(t) ? e = t : e = ze, e;
  },
  pe = function pe(t, e, n, s) {
    var a, l, c;
    var r = {
      channel: Wa,
      context: _objectSpread(_objectSpread({
        traits: I(o.session.userTraits.value),
        sessionId: o.session.sessionInfo.value.id || void 0,
        sessionStart: o.session.sessionInfo.value.sessionStart || void 0
      }, o.consents.enabled.value && {
        consentManagement: {
          deniedConsentIds: I(o.consents.data.value.deniedConsentIds),
          allowedConsentIds: I(o.consents.data.value.allowedConsentIds),
          provider: o.consents.provider.value,
          resolutionStrategy: o.consents.resolutionStrategy.value
        }
      }), {}, {
        "ua-ch": o.context["ua-ch"].value,
        app: o.context.app.value,
        library: o.context.library.value,
        userAgent: o.context.userAgent.value,
        os: o.context.os.value,
        locale: o.context.locale.value,
        screen: o.context.screen.value,
        campaign: ca(globalThis.location.href),
        page: sl(n),
        timezone: o.context.timezone.value
      }),
      originalTimestamp: qa(),
      integrations: ze,
      messageId: ss(),
      userId: t.userId || o.session.userId.value
    };
    me((a = o.storage.entries.value.anonymousId) == null ? void 0 : a.type) ? r.anonymousId = o.session.anonymousId.value : r.anonymousId = ht(), o.storage.trulyAnonymousTracking.value && (r.context.trulyAnonymousTracking = !0), t.type === "identify" && (r.context.traits = ((l = o.storage.entries.value.userTraits) == null ? void 0 : l.type) !== ie ? I(o.session.userTraits.value) : t.context.traits), t.type === "group" && ((t.groupId || o.session.groupId.value) && (r.groupId = t.groupId || o.session.groupId.value), (t.traits || o.session.groupTraits.value) && (r.traits = ((c = o.storage.entries.value.groupTraits) == null ? void 0 : c.type) !== ie ? I(o.session.groupTraits.value) : t.traits));
    var i = w(t, r);
    return i.event === void 0 && (i.event = null), i.properties === void 0 && (i.properties = null), cl(i, e), il(i, s), i.integrations = ul(i.integrations), i;
  };
var dl = /*#__PURE__*/function () {
  function dl(e) {
    _classCallCheck(this, dl);
    this.logger = e;
  }
  /**
  * Generate a 'page' event based on the user-input fields
  * @param category Page's category
  * @param name Page name
  * @param properties Page properties
  * @param options API options
  */
  _createClass(dl, [{
    key: "generatePageEvent",
    value: function generatePageEvent(e, n, s, r) {
      var i = s !== null && s !== void 0 ? s : {};
      return i.name = n, i.category = e, i = rl(i, r), pe({
        properties: i,
        name: n,
        category: e,
        type: "page"
      }, r, i, this.logger);
    }
    /**
    * Generate a 'track' event based on the user-input fields
    * @param event The event name
    * @param properties Event properties
    * @param options API options
    */
  }, {
    key: "generateTrackEvent",
    value: function generateTrackEvent(e, n, s) {
      return pe({
        properties: n,
        event: e,
        type: "track"
      }, s, void 0, this.logger);
    }
    /**
    * Generate an 'identify' event based on the user-input fields
    * @param userId New user ID
    * @param traits new traits
    * @param options API options
    */
  }, {
    key: "generateIdentifyEvent",
    value: function generateIdentifyEvent(e, n, s) {
      return pe({
        userId: e,
        type: "identify",
        context: {
          traits: n
        }
      }, s, void 0, this.logger);
    }
    /**
    * Generate an 'alias' event based on the user-input fields
    * @param to New user ID
    * @param from Old user ID
    * @param options API options
    */
  }, {
    key: "generateAliasEvent",
    value: function generateAliasEvent(e, n, s) {
      var i = pe({
        previousId: n,
        type: "alias"
      }, s, void 0, this.logger);
      return i.userId = e !== null && e !== void 0 ? e : i.userId, i;
    }
    /**
    * Generate a 'group' event based on the user-input fields
    * @param groupId New group ID
    * @param traits new group traits
    * @param options API options
    */
  }, {
    key: "generateGroupEvent",
    value: function generateGroupEvent(e, n, s) {
      var r = {
        type: "group"
      };
      return e && (r.groupId = e), n && (r.traits = n), pe(r, s, void 0, this.logger);
    }
    /**
    * Generates a new RudderEvent object based on the user-input fields
    * @param event API event parameters object
    * @returns A RudderEvent object
    */
  }, {
    key: "create",
    value: function create(e) {
      var n;
      switch (e.type) {
        case "page":
          n = this.generatePageEvent(e.category, e.name, e.properties, e.options);
          break;
        case "track":
          n = this.generateTrackEvent(e.name, e.properties, e.options);
          break;
        case "identify":
          n = this.generateIdentifyEvent(e.userId, e.traits, e.options);
          break;
        case "alias":
          n = this.generateAliasEvent(e.to, e.from, e.options);
          break;
        case "group":
          n = this.generateGroupEvent(e.groupId, e.traits, e.options);
          break;
      }
      return n;
    }
  }]);
  return dl;
}();
var gl = /*#__PURE__*/function () {
  /**
  *
  * @param eventRepository Event repository instance
  * @param userSessionManager UserSession Manager instance
  * @param errorHandler Error handler object
  * @param logger Logger object
  */
  function gl(e, n, s, r) {
    _classCallCheck(this, gl);
    this.eventRepository = e, this.userSessionManager = n, this.errorHandler = s, this.logger = r, this.eventFactory = new dl(this.logger), this.onError = this.onError.bind(this);
  }
  /**
  * Initializes the event manager
  */
  _createClass(gl, [{
    key: "init",
    value: function init() {
      this.eventRepository.init();
    }
  }, {
    key: "resume",
    value: function resume() {
      this.eventRepository.resume();
    }
    /**
    * Consumes a new incoming event
    * @param event Incoming event data
    */
  }, {
    key: "addEvent",
    value: function addEvent(e) {
      this.userSessionManager.refreshSession();
      var n = this.eventFactory.create(e);
      n ? this.eventRepository.enqueue(n, e.callback) : this.onError(new Error(zr));
    }
    /**
    * Handles error
    * @param error The error object
    */
  }, {
    key: "onError",
    value: function onError(e, n, s) {
      if (this.errorHandler) this.errorHandler.onError(e, mt, n, s);else throw e;
    }
  }]);
  return gl;
}();
var hl = /*#__PURE__*/function () {
  function hl(e, n, s, r) {
    _classCallCheck(this, hl);
    this.storeManager = r, this.pluginsManager = s, this.logger = n, this.errorHandler = e, this.onError = this.onError.bind(this);
  }
  /**
  * Initialize User session with values from storage
  */
  _createClass(hl, [{
    key: "init",
    value: function init() {
      this.syncStorageDataToState(), this.registerEffects();
    }
  }, {
    key: "syncStorageDataToState",
    value: function syncStorageDataToState() {
      var _s2;
      this.migrateStorageIfNeeded(), this.migrateDataFromPreviousStorage(), this.setUserId(this.getUserId()), this.setUserTraits(this.getUserTraits()), this.setGroupId(this.getGroupId()), this.setGroupTraits(this.getGroupTraits());
      var _o$loadOptions$value = o.loadOptions.value,
        e = _o$loadOptions$value.externalAnonymousIdCookieName,
        n = _o$loadOptions$value.anonymousIdOptions;
      var s;
      Ge(e) && typeof e == "string" && (s = this.getExternalAnonymousIdByCookieName(e)), this.setAnonymousId((_s2 = s) !== null && _s2 !== void 0 ? _s2 : this.getAnonymousId(n)), this.setAuthToken(this.getAuthToken()), this.setInitialReferrerInfo(), this.configureSessionTracking();
    }
  }, {
    key: "configureSessionTracking",
    value: function configureSessionTracking() {
      var e = this.getSessionInfo();
      if (this.isPersistenceEnabledForStorageEntry("sessionInfo")) {
        var _this$getSessionInfo;
        var n = this.getConfiguredSessionTrackingInfo(),
          s = (_this$getSessionInfo = this.getSessionInfo()) !== null && _this$getSessionInfo !== void 0 ? _this$getSessionInfo : zi;
        e = _objectSpread(_objectSpread(_objectSpread({}, s), n), {}, {
          autoTrack: n.autoTrack && s.manualTrack !== !0
        });
      }
      this.setSessionInfo(e);
    }
  }, {
    key: "setInitialReferrerInfo",
    value: function setInitialReferrerInfo() {
      var e = this.getInitialReferrer(),
        n = this.getInitialReferringDomain();
      if (e && n) this.setInitialReferrer(e), this.setInitialReferringDomain(n);else {
        var s = e || ts();
        this.setInitialReferrer(s), this.setInitialReferringDomain(qn(s));
      }
    }
  }, {
    key: "isPersistenceEnabledForStorageEntry",
    value: function isPersistenceEnabledForStorageEntry(e) {
      var n;
      return me((n = o.storage.entries.value[e]) == null ? void 0 : n.type);
    }
  }, {
    key: "migrateDataFromPreviousStorage",
    value: function migrateDataFromPreviousStorage() {
      var _this20 = this;
      var e = o.storage.entries.value,
        n = [G, B, F];
      Object.keys(e).forEach(function (s) {
        var l, c;
        var r = s,
          i = (l = e[r]) == null ? void 0 : l.type,
          a = (c = _this20.storeManager) == null ? void 0 : c.getStore(de[i]);
        a && n.forEach(function (d) {
          var m;
          var p = (m = _this20.storeManager) == null ? void 0 : m.getStore(de[d]);
          if (p && d !== i) {
            var N = p.get(ue[r]);
            qs(N) && a.set(ue[r], N), p.remove(ue[r]);
          }
        });
      });
    }
  }, {
    key: "migrateStorageIfNeeded",
    value: function migrateStorageIfNeeded() {
      var _this21 = this;
      if (!o.storage.migrate.value) return;
      var e = [Hn, jn, Vn],
        n = [];
      e.forEach(function (s) {
        var i;
        var r = (i = _this21.storeManager) == null ? void 0 : i.getStore(s);
        r && n.push(r);
      }), Object.keys(ue).forEach(function (s) {
        var r = ue[s];
        n.forEach(function (i) {
          var l;
          var a = (l = _this21.pluginsManager) == null ? void 0 : l.invokeSingle("storage.migrate", r, i.engine, _this21.errorHandler, _this21.logger);
          V(a) || i.set(r, a);
        });
      });
    }
  }, {
    key: "getConfiguredSessionTrackingInfo",
    value: function getConfiguredSessionTrackingInfo() {
      var r, i, a, l, c;
      var e = ((r = o.loadOptions.value.sessions) == null ? void 0 : r.autoTrack) !== !1;
      if (!e) return {
        autoTrack: e
      };
      var n;
      var s = (i = o.loadOptions.value.sessions) == null ? void 0 : i.timeout;
      return Jn(s) ? n = s : ((a = this.logger) == null || a.warn(bi(Ee, s, Se)), n = Se), n === 0 && ((l = this.logger) == null || l.warn(Ti(Ee)), e = !1), n > 0 && n < Gt && ((c = this.logger) == null || c.warn(Ri(Ee, n, Gt))), {
        timeout: n,
        autoTrack: e
      };
    }
    /**
    * Handles error
    * @param error The error object
    */
  }, {
    key: "onError",
    value: function onError(e) {
      if (this.errorHandler) this.errorHandler.onError(e, Ee);else throw e;
    }
    /**
    * A function to sync values in storage
    * @param sessionKey
    * @param value
    */
  }, {
    key: "syncValueToStorage",
    value: function syncValueToStorage(e, n) {
      var a, l, c;
      var s = o.storage.entries.value,
        r = (a = s[e]) == null ? void 0 : a.type,
        i = (l = s[e]) == null ? void 0 : l.key;
      if (me(r)) {
        var d = (c = this.storeManager) == null ? void 0 : c.getStore(de[r]);
        n && k(n) || xe(n) ? d == null || d.set(i, n) : d == null || d.remove(i);
      }
    }
    /**
    * Function to update storage whenever state value changes
    */
  }, {
    key: "registerEffects",
    value: function registerEffects() {
      var _this22 = this;
      Qn.forEach(function (e) {
        W(function () {
          _this22.syncValueToStorage(e, o.session[e].value);
        });
      });
    }
    /**
    * Sets anonymous id in the following precedence:
    *
    * 1. anonymousId: Id directly provided to the function.
    * 2. rudderAmpLinkerParam: value generated from linker query parm (rudderstack)
    *    using parseLinker util.
    * 3. generateUUID: A new unique id is generated and assigned.
    */
  }, {
    key: "setAnonymousId",
    value: function setAnonymousId(e, n) {
      var r;
      var s = e;
      this.isPersistenceEnabledForStorageEntry("anonymousId") ? (!s && n && (s = (r = this.pluginsManager) == null ? void 0 : r.invokeSingle("userSession.anonymousIdGoogleLinker", n)), s = s || ht()) : s = R.anonymousId, o.session.anonymousId.value = s;
    }
    /**
    * Fetches anonymousId
    * @param options option to fetch it from external source
    * @returns anonymousId
    */
  }, {
    key: "getAnonymousId",
    value: function getAnonymousId(e) {
      var s, r;
      var n = (s = o.storage.entries.value.anonymousId) == null ? void 0 : s.type;
      if (me(n)) {
        var i = this.getEntryValue("anonymousId");
        !i && e && (i = (r = this.pluginsManager) == null ? void 0 : r.invokeSingle("storage.getAnonymousId", x, e)), o.session.anonymousId.value = i || ht();
      }
      return o.session.anonymousId.value;
    }
  }, {
    key: "getEntryValue",
    value: function getEntryValue(e) {
      var r, i, a;
      var n = o.storage.entries.value,
        s = (r = n[e]) == null ? void 0 : r.type;
      if (me(s)) {
        var _ref17;
        var l = (i = this.storeManager) == null ? void 0 : i.getStore(de[s]),
          c = (a = n[e]) == null ? void 0 : a.key;
        return (_ref17 = l == null ? void 0 : l.get(c)) !== null && _ref17 !== void 0 ? _ref17 : null;
      }
      return null;
    }
  }, {
    key: "getExternalAnonymousIdByCookieName",
    value: function getExternalAnonymousIdByCookieName(e) {
      var _n$getItem;
      var n = x(G);
      return n != null && n.isEnabled ? (_n$getItem = n.getItem(e)) !== null && _n$getItem !== void 0 ? _n$getItem : null : null;
    }
    /**
    * Fetches User Id
    * @returns
    */
  }, {
    key: "getUserId",
    value: function getUserId() {
      return this.getEntryValue("userId");
    }
    /**
    * Fetches User Traits
    * @returns
    */
  }, {
    key: "getUserTraits",
    value: function getUserTraits() {
      return this.getEntryValue("userTraits");
    }
    /**
    * Fetches Group Id
    * @returns
    */
  }, {
    key: "getGroupId",
    value: function getGroupId() {
      return this.getEntryValue("groupId");
    }
    /**
    * Fetches Group Traits
    * @returns
    */
  }, {
    key: "getGroupTraits",
    value: function getGroupTraits() {
      return this.getEntryValue("groupTraits");
    }
    /**
    * Fetches Initial Referrer
    * @returns
    */
  }, {
    key: "getInitialReferrer",
    value: function getInitialReferrer() {
      return this.getEntryValue("initialReferrer");
    }
    /**
    * Fetches Initial Referring domain
    * @returns
    */
  }, {
    key: "getInitialReferringDomain",
    value: function getInitialReferringDomain() {
      return this.getEntryValue("initialReferringDomain");
    }
    /**
    * Fetches session tracking information from storage
    * @returns
    */
  }, {
    key: "getSessionInfo",
    value: function getSessionInfo() {
      return this.getEntryValue("sessionInfo");
    }
    /**
    * Fetches auth token from storage
    * @returns
    */
  }, {
    key: "getAuthToken",
    value: function getAuthToken() {
      return this.getEntryValue("authToken");
    }
    /**
    * If session is active it returns the sessionId
    * @returns
    */
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      var _e$id;
      var e = o.session.sessionInfo.value;
      return e.autoTrack && !on(e.expiresAt) || e.manualTrack ? (_e$id = e.id) !== null && _e$id !== void 0 ? _e$id : null : null;
    }
    /**
    * A function to update current session info after each event call
    */
  }, {
    key: "refreshSession",
    value: function refreshSession() {
      var e = o.session.sessionInfo.value;
      (e.autoTrack || e.manualTrack) && (e.autoTrack && this.startOrRenewAutoTracking(), e = o.session.sessionInfo.value, e.sessionStart === void 0 ? o.session.sessionInfo.value = _objectSpread(_objectSpread({}, e), {}, {
        sessionStart: !0
      }) : e.sessionStart && (o.session.sessionInfo.value = _objectSpread(_objectSpread({}, e), {}, {
        sessionStart: !1
      })));
    }
    /**
    * Reset state values
    * @param resetAnonymousId
    * @param noNewSessionStart
    * @returns
    */
  }, {
    key: "reset",
    value: function reset(e, n) {
      var _this23 = this;
      var s = o.session,
        _s$sessionInfo$value = s.sessionInfo.value,
        r = _s$sessionInfo$value.manualTrack,
        i = _s$sessionInfo$value.autoTrack;
      M(function () {
        s.userId.value = R.userId, s.userTraits.value = R.userTraits, s.groupId.value = R.groupId, s.groupTraits.value = R.groupTraits, s.authToken.value = R.authToken, e && _this23.setAnonymousId(), !n && (i ? (s.sessionInfo.value = R.sessionInfo, _this23.startOrRenewAutoTracking()) : r && _this23.startManualTrackingInternal());
      });
    }
  }, {
    key: "setSessionInfo",
    value: function setSessionInfo(e) {
      o.session.sessionInfo.value = this.isPersistenceEnabledForStorageEntry("sessionInfo") ? e : R.sessionInfo, o.session.sessionInfo.value.autoTrack && this.startOrRenewAutoTracking();
    }
    /**
    * Set user Id
    * @param userId
    */
  }, {
    key: "setUserId",
    value: function setUserId(e) {
      o.session.userId.value = this.isPersistenceEnabledForStorageEntry("userId") && e ? e : R.userId;
    }
    /**
    * Set user traits
    * @param traits
    */
  }, {
    key: "setUserTraits",
    value: function setUserTraits(e) {
      var _o$session$userTraits;
      o.session.userTraits.value = this.isPersistenceEnabledForStorageEntry("userTraits") && e ? w((_o$session$userTraits = o.session.userTraits.value) !== null && _o$session$userTraits !== void 0 ? _o$session$userTraits : {}, e) : R.userTraits;
    }
    /**
    * Set group Id
    * @param groupId
    */
  }, {
    key: "setGroupId",
    value: function setGroupId(e) {
      o.session.groupId.value = this.isPersistenceEnabledForStorageEntry("groupId") && e ? e : R.groupId;
    }
    /**
    * Set group traits
    * @param traits
    */
  }, {
    key: "setGroupTraits",
    value: function setGroupTraits(e) {
      var _o$session$groupTrait;
      o.session.groupTraits.value = this.isPersistenceEnabledForStorageEntry("groupTraits") && e ? w((_o$session$groupTrait = o.session.groupTraits.value) !== null && _o$session$groupTrait !== void 0 ? _o$session$groupTrait : {}, e) : R.groupTraits;
    }
    /**
    * Set initial referrer
    * @param referrer
    */
  }, {
    key: "setInitialReferrer",
    value: function setInitialReferrer(e) {
      o.session.initialReferrer.value = this.isPersistenceEnabledForStorageEntry("initialReferrer") && e ? e : R.initialReferrer;
    }
    /**
    * Set initial referring domain
    * @param {String} referringDomain
    */
  }, {
    key: "setInitialReferringDomain",
    value: function setInitialReferringDomain(e) {
      o.session.initialReferringDomain.value = this.isPersistenceEnabledForStorageEntry("initialReferringDomain") && e ? e : R.initialReferringDomain;
    }
    /**
    * A function to check for existing session details and depending on that create a new session
    */
  }, {
    key: "startOrRenewAutoTracking",
    value: function startOrRenewAutoTracking() {
      var e = o.session.sessionInfo.value;
      if (on(e.expiresAt)) o.session.sessionInfo.value = tl(e.timeout);else {
        var n = Date.now(),
          s = e.timeout;
        o.session.sessionInfo.value = w(e, {
          expiresAt: n + s
          // set the expiry time of the session
        });
      }
    }
    /**
    * A function method to start a manual session
    * @param {number} id     session identifier
    * @returns
    */
  }, {
    key: "start",
    value: function start(e) {
      o.session.sessionInfo.value = nl(e, this.logger);
    }
    /**
    * An internal function to start manual session
    */
  }, {
    key: "startManualTrackingInternal",
    value: function startManualTrackingInternal() {
      this.start(Date.now());
    }
    /**
    * A public method to end an ongoing session.
    */
  }, {
    key: "end",
    value: function end() {
      o.session.sessionInfo.value = {};
    }
    /**
    * Set auth token
    * @param userId
    */
  }, {
    key: "setAuthToken",
    value: function setAuthToken(e) {
      o.session.authToken.value = this.isPersistenceEnabledForStorageEntry("authToken") && e ? e : R.authToken;
    }
  }]);
  return hl;
}();
var an = "dataplaneEventsQueue",
  ln = "destinationsEventsQueue",
  fl = "transformEvent",
  pl = function pl(t, e) {
    return Object.keys(t).filter(function (n) {
      return t[n] !== !0 || !e[n];
    }).reduce(function (n, s) {
      var r = I(n);
      return r[s] = t[s], r;
    }, {});
  },
  vl = function vl(t, e) {
    var _t$integrations;
    var n = I(t),
      s = (_t$integrations = t.integrations) !== null && _t$integrations !== void 0 ? _t$integrations : ze,
      r = e.nativeDestinations.integrationsConfig.value,
      i = pl(s, r);
    return n.integrations = w(r, i), n;
  },
  El = function El(t) {
    var e, n, s;
    return t.consents.preConsent.value.enabled && ((e = t.consents.preConsent.value.events) == null ? void 0 : e.delivery) === "buffer" && (((n = t.consents.preConsent.value.storage) == null ? void 0 : n.strategy) === "session" || ((s = t.consents.preConsent.value.storage) == null ? void 0 : s.strategy) === "none");
  };
var ml = /*#__PURE__*/function () {
  /**
  *
  * @param pluginsManager Plugins manager instance
  * @param storeManager Store Manager instance
  * @param errorHandler Error handler object
  * @param logger Logger object
  */
  function ml(e, n, s, r) {
    _classCallCheck(this, ml);
    this.pluginsManager = e, this.errorHandler = s, this.logger = r, this.httpClient = new It(s, r), this.storeManager = n, this.onError = this.onError.bind(this);
  }
  /**
  * Initializes the event repository
  */
  _createClass(ml, [{
    key: "init",
    value: function init() {
      var _this24 = this;
      try {
        this.dataplaneEventsQueue = this.pluginsManager.invokeSingle("".concat(an, ".init"), o, this.httpClient, this.storeManager, this.errorHandler, this.logger);
      } catch (s) {
        this.onError(s, Li);
      }
      try {
        this.dmtEventsQueue = this.pluginsManager.invokeSingle("".concat(fl, ".init"), o, this.pluginsManager, this.httpClient, this.storeManager, this.errorHandler, this.logger);
      } catch (s) {
        this.onError(s, Ci);
      }
      try {
        this.destinationsEventsQueue = this.pluginsManager.invokeSingle("".concat(ln, ".init"), o, this.pluginsManager, this.storeManager, this.dmtEventsQueue, this.errorHandler, this.logger);
      } catch (s) {
        this.onError(s, ki);
      }
      W(function () {
        var s, r;
        o.nativeDestinations.clientDestinationsReady.value === !0 && ((s = _this24.destinationsEventsQueue) == null || s.start(), (r = _this24.dmtEventsQueue) == null || r.start());
      });
      var e = El(o);
      var n;
      W(function () {
        var i, a;
        var s = o.loadOptions.value.bufferDataPlaneEventsUntilReady === !0 && o.nativeDestinations.clientDestinationsReady.value === !1;
        (o.nativeDestinations.activeDestinations.value.some(function (l) {
          return vo(l);
        }) === !1 || s === !1) && !e && ((i = _this24.dataplaneEventsQueue) == null ? void 0 : i.scheduleTimeoutActive) !== !0 && (globalThis.clearTimeout(n), (a = _this24.dataplaneEventsQueue) == null || a.start());
      }), o.loadOptions.value.bufferDataPlaneEventsUntilReady === !0 && (n = globalThis.setTimeout(function () {
        var s, r;
        ((s = _this24.dataplaneEventsQueue) == null ? void 0 : s.scheduleTimeoutActive) !== !0 && ((r = _this24.dataplaneEventsQueue) == null || r.start());
      }, o.loadOptions.value.dataPlaneEventsBufferTimeout));
    }
  }, {
    key: "resume",
    value: function resume() {
      var e, n, s, r;
      ((e = this.dataplaneEventsQueue) == null ? void 0 : e.scheduleTimeoutActive) !== !0 && (o.consents.postConsent.value.discardPreConsentEvents && ((n = this.dataplaneEventsQueue) == null || n.clear(), (s = this.destinationsEventsQueue) == null || s.clear()), (r = this.dataplaneEventsQueue) == null || r.start());
    }
    /**
    * Enqueues the event for processing
    * @param event RudderEvent object
    * @param callback API callback function
    */
  }, {
    key: "enqueue",
    value: function enqueue(e, n) {
      var s;
      try {
        s = vl(e, o), this.pluginsManager.invokeSingle("".concat(an, ".enqueue"), o, this.dataplaneEventsQueue, s, this.errorHandler, this.logger);
      } catch (r) {
        this.onError(r, Mi);
      }
      try {
        var r = I(e);
        this.pluginsManager.invokeSingle("".concat(ln, ".enqueue"), o, this.destinationsEventsQueue, r, this.errorHandler, this.logger);
      } catch (r) {
        this.onError(r, Ui);
      }
      try {
        n == null || n(s);
      } catch (r) {
        this.onError(r, Di);
      }
    }
    /**
    * Handles error
    * @param error The error object
    * @param customMessage a message
    * @param shouldAlwaysThrow if it should throw or use logger
    */
  }, {
    key: "onError",
    value: function onError(e, n, s) {
      if (this.errorHandler) this.errorHandler.onError(e, rr, n, s);else throw e;
    }
  }]);
  return ml;
}();
var cn = function cn(t) {
  var e = new CustomEvent(t, {
    detail: {
      analyticsInstance: globalThis.rudderanalytics
    },
    bubbles: !0,
    cancelable: !0,
    composed: !0
  });
  globalThis.document.dispatchEvent(e);
};
var un = /*#__PURE__*/function () {
  /**
  * Initialize services and components or use default ones if singletons
  */
  function un() {
    _classCallCheck(this, un);
    this.preloadBuffer = new Dn(), this.initialized = !1, this.errorHandler = Qe, this.logger = Q, this.externalSrcLoader = new Rn(this.errorHandler, this.logger), this.capabilitiesManager = new Qa(this.errorHandler, this.logger), this.httpClient = Ao;
  }
  /**
  * Start application lifecycle if not already started
  */
  _createClass(un, [{
    key: "load",
    value: function load(e, n) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var a;
      if (o.lifecycle.status.value) return;
      var r = I(n),
        i = I(s);
      yn(n) && (i = n, r = void 0), M(function () {
        o.lifecycle.writeKey.value = e, o.lifecycle.dataPlaneUrl.value = r, o.loadOptions.value = ya(o.loadOptions.value, i), o.lifecycle.status.value = "mounted";
      }), o.loadOptions.value.logLevel && ((a = this.logger) == null || a.setMinLogLevel(o.loadOptions.value.logLevel)), Fe("state", o, e), this.startLifecycle();
    }
    // Start lifecycle methods
    /**
       * Orchestrate the lifecycle of the application phases/status
       */
  }, {
    key: "startLifecycle",
    value: function startLifecycle() {
      var _this25 = this;
      W(function () {
        try {
          switch (o.lifecycle.status.value) {
            case "mounted":
              _this25.onMounted();
              break;
            case "browserCapabilitiesReady":
              _this25.onBrowserCapabilitiesReady();
              break;
            case "configured":
              _this25.onConfigured();
              break;
            case "pluginsLoading":
              break;
            case "pluginsReady":
              _this25.onPluginsReady();
              break;
            case "initialized":
              _this25.onInitialized();
              break;
            case "loaded":
              _this25.onLoaded();
              break;
            case "destinationsLoading":
              break;
            case "destinationsReady":
              _this25.onDestinationsReady();
              break;
            case "ready":
              _this25.onReady();
              break;
            case "readyExecuted":
            default:
              break;
          }
        } catch (e) {
          _this25.errorHandler.onError(_e(e, "Failed to load the SDK"), Ye);
        }
      });
    }
  }, {
    key: "onBrowserCapabilitiesReady",
    value: function onBrowserCapabilitiesReady() {
      br(this), this.prepareInternalServices(), this.loadConfig();
    }
  }, {
    key: "onLoaded",
    value: function onLoaded() {
      this.processBufferedEvents(), o.consents.preConsent.value.enabled === !0 ? o.lifecycle.status.value = "ready" : this.loadDestinations();
    }
    /**
    * Load browser polyfill if required
    */
  }, {
    key: "onMounted",
    value: function onMounted() {
      this.capabilitiesManager.init();
    }
    /**
    * Enqueue in SDK preload buffer events, used from preloadBuffer component
    */
  }, {
    key: "enqueuePreloadBufferEvents",
    value: function enqueuePreloadBufferEvents(e) {
      var _this26 = this;
      Array.isArray(e) && e.forEach(function (n) {
        return _this26.preloadBuffer.enqueue(I(n));
      });
    }
    /**
    * Process the buffer preloaded events by passing their arguments to the respective facade methods
    */
  }, {
    key: "processDataInPreloadBuffer",
    value: function processDataInPreloadBuffer() {
      for (; this.preloadBuffer.size() > 0;) {
        var _e3 = this.preloadBuffer.dequeue();
        _e3 && Tr(_toConsumableArray(_e3), this);
      }
    }
  }, {
    key: "prepareInternalServices",
    value: function prepareInternalServices() {
      this.pluginsManager = new To(Gn, this.errorHandler, this.logger), this.storeManager = new la(this.pluginsManager, this.errorHandler, this.logger), this.configManager = new Ba(this.httpClient, this.errorHandler, this.logger), this.userSessionManager = new hl(this.errorHandler, this.logger, this.pluginsManager, this.storeManager), this.eventRepository = new ml(this.pluginsManager, this.storeManager, this.errorHandler, this.logger), this.eventManager = new gl(this.eventRepository, this.userSessionManager, this.errorHandler, this.logger);
    }
    /**
    * Load configuration
    */
  }, {
    key: "loadConfig",
    value: function loadConfig() {
      var e;
      o.lifecycle.writeKey.value && this.httpClient.setAuthHeader(o.lifecycle.writeKey.value), (e = this.configManager) == null || e.init();
    }
    /**
    * Initialize the storage and event queue
    */
  }, {
    key: "onPluginsReady",
    value: function onPluginsReady() {
      var e, n, s, r, i;
      this.errorHandler.init(this.externalSrcLoader), (e = this.storeManager) == null || e.init(), (n = this.userSessionManager) == null || n.init(), o.consents.enabled.value && !o.consents.initialized.value && ((s = this.pluginsManager) == null || s.invokeSingle("consentManager.init", o, this.logger), o.consents.preConsent.value.enabled === !1 && ((r = this.pluginsManager) == null || r.invokeSingle("consentManager.updateConsentsInfo", o, this.storeManager, this.logger))), (i = this.eventManager) == null || i.init(), o.lifecycle.status.value = "initialized";
    }
    /**
    * Load plugins
    */
  }, {
    key: "onConfigured",
    value: function onConfigured() {
      var e;
      (e = this.pluginsManager) == null || e.init();
    }
    /**
      * Trigger onLoaded callback if any is provided in config & emit initialised event
      */
  }, {
    key: "onInitialized",
    value: function onInitialized() {
      this.processDataInPreloadBuffer(), f(o.loadOptions.value.onLoaded) && o.loadOptions.value.onLoaded(globalThis.rudderanalytics), M(function () {
        o.lifecycle.loaded.value = !0, o.lifecycle.status.value = "loaded";
      }), this.initialized = !0, cn("RSA_Initialised");
    }
    /**
    * Emit ready event
    */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "onReady",
    value: function onReady() {
      var _this27 = this;
      o.lifecycle.status.value = "readyExecuted", o.eventBuffer.readyCallbacksArray.value.forEach(function (e) {
        try {
          e();
        } catch (n) {
          _this27.errorHandler.onError(n, Ye, Vt);
        }
      }), cn("RSA_Ready");
    }
    /**
    * Consume preloaded events buffer
    */
  }, {
    key: "processBufferedEvents",
    value: function processBufferedEvents() {
      var e = o.eventBuffer.toBeProcessedArray.value;
      for (; e.length > 0;) {
        var n = e.shift();
        if (o.eventBuffer.toBeProcessedArray.value = e, n) {
          var s = n[0];
          f(this[s]) && this[s].apply(this, _toConsumableArray(n.slice(1)).concat([!0]));
        }
        e = o.eventBuffer.toBeProcessedArray.value;
      }
    }
    /**
    * Load device mode destinations
    */
  }, {
    key: "loadDestinations",
    value: function loadDestinations() {
      var n, s;
      if (o.nativeDestinations.clientDestinationsReady.value) return;
      (n = this.pluginsManager) == null || n.invokeSingle("nativeDestinations.setActiveDestinations", o, this.pluginsManager, this.errorHandler, this.logger);
      var e = o.nativeDestinations.activeDestinations.value.length;
      if (e === 0) {
        o.lifecycle.status.value = "destinationsReady";
        return;
      }
      o.lifecycle.status.value = "destinationsLoading", (s = this.pluginsManager) == null || s.invokeSingle("nativeDestinations.load", o, this.externalSrcLoader, this.errorHandler, this.logger), W(function () {
        (e === 0 || o.nativeDestinations.initializedDestinations.value.length + o.nativeDestinations.failedDestinations.value.length === e) && M(function () {
          o.lifecycle.status.value = "destinationsReady", o.nativeDestinations.clientDestinationsReady.value = !0;
        });
      });
    }
    /**
    * Move to the ready state
    */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "onDestinationsReady",
    value: function onDestinationsReady() {
      o.lifecycle.status.value !== "ready" && (o.lifecycle.status.value = "ready");
    }
    // End lifecycle methods
    // Start consumer exposed methods
  }, {
    key: "ready",
    value: function ready(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var s = "ready";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[s, e]]);
        return;
      }
      if (this.errorHandler.leaveBreadcrumb("New ".concat(s, " invocation")), !f(e)) {
        this.logger.error(ci(sr));
        return;
      }
      if (o.lifecycle.status.value === "readyExecuted") try {
        e();
      } catch (r) {
        this.errorHandler.onError(r, Ye, Vt);
      } else o.eventBuffer.readyCallbacksArray.value = [].concat(_toConsumableArray(o.eventBuffer.readyCallbacksArray.value), [e]);
    }
  }, {
    key: "page",
    value: function page(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r;
      var s = "page";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[s, e]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New ".concat(s, " event")), o.metrics.triggered.value += 1, (r = this.eventManager) == null || r.addEvent({
        type: "page",
        category: e.category,
        name: e.name,
        properties: e.properties,
        options: e.options,
        callback: e.callback
      }), o.capabilities.isAdBlocked.value === !0 && e.category !== Ut && this.page(Ue(Ut, cr, {
        // 'title' is intentionally omitted as it does not make sense
        // in v3 implementation
        path: ur
      }, o.loadOptions.value.sendAdblockPageOptions));
    }
  }, {
    key: "track",
    value: function track(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r;
      var s = "track";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[s, e]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New ".concat(s, " event")), o.metrics.triggered.value += 1, (r = this.eventManager) == null || r.addEvent({
        type: s,
        name: e.name || void 0,
        properties: e.properties,
        options: e.options,
        callback: e.callback
      });
    }
  }, {
    key: "identify",
    value: function identify(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i, a, l;
      var s = "identify";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[s, e]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New ".concat(s, " event")), o.metrics.triggered.value += 1, !!(e.userId && o.session.userId.value && e.userId !== o.session.userId.value) && this.reset(), H(e.userId) || (i = this.userSessionManager) == null || i.setUserId(e.userId), (a = this.userSessionManager) == null || a.setUserTraits(e.traits), (l = this.eventManager) == null || l.addEvent({
        type: s,
        userId: e.userId,
        traits: e.traits,
        options: e.options,
        callback: e.callback
      });
    }
  }, {
    key: "alias",
    value: function alias(e) {
      var _ref18, _e$from;
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i, a, l;
      var s = "alias";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[s, e]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New ".concat(s, " event")), o.metrics.triggered.value += 1;
      var r = (_ref18 = (_e$from = e.from) !== null && _e$from !== void 0 ? _e$from : (i = this.userSessionManager) == null ? void 0 : i.getUserId()) !== null && _ref18 !== void 0 ? _ref18 : (a = this.userSessionManager) == null ? void 0 : a.getAnonymousId();
      (l = this.eventManager) == null || l.addEvent({
        type: s,
        to: e.to,
        from: r,
        options: e.options,
        callback: e.callback
      });
    }
  }, {
    key: "group",
    value: function group(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r, i, a;
      var s = "group";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[s, e]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New ".concat(s, " event")), o.metrics.triggered.value += 1, H(e.groupId) || (r = this.userSessionManager) == null || r.setGroupId(e.groupId), (i = this.userSessionManager) == null || i.setGroupTraits(e.traits), (a = this.eventManager) == null || a.addEvent({
        type: s,
        groupId: e.groupId,
        traits: e.traits,
        options: e.options,
        callback: e.callback
      });
    }
  }, {
    key: "reset",
    value: function reset(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r;
      var s = "reset";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[s, e]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New ".concat(s, " invocation, resetAnonymousId: ").concat(e)), (r = this.userSessionManager) == null || r.reset(e);
    }
  }, {
    key: "getAnonymousId",
    value: function getAnonymousId(e) {
      var n;
      return (n = this.userSessionManager) == null ? void 0 : n.getAnonymousId(e);
    }
  }, {
    key: "setAnonymousId",
    value: function setAnonymousId(e, n) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var i;
      var r = "setAnonymousId";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[r, e, n]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New ".concat(r, " invocation")), (i = this.userSessionManager) == null || i.setAnonymousId(e, n);
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getUserId",
    value: function getUserId() {
      return o.session.userId.value;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getUserTraits",
    value: function getUserTraits() {
      return o.session.userTraits.value;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getGroupId",
    value: function getGroupId() {
      return o.session.groupId.value;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getGroupTraits",
    value: function getGroupTraits() {
      return o.session.groupTraits.value;
    }
  }, {
    key: "startSession",
    value: function startSession(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r;
      var s = "startSession";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[s, e]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New ".concat(s, " invocation")), (r = this.userSessionManager) == null || r.start(e);
    }
  }, {
    key: "endSession",
    value: function endSession() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var s;
      var n = "endSession";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[n]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New ".concat(n, " invocation")), (s = this.userSessionManager) == null || s.end();
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      var _ref19;
      var n;
      return (_ref19 = (n = this.userSessionManager) == null ? void 0 : n.getSessionId()) !== null && _ref19 !== void 0 ? _ref19 : null;
    }
  }, {
    key: "consent",
    value: function consent(e) {
      var _this28 = this;
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r, i, a, l;
      var s = "consent";
      if (!o.lifecycle.loaded.value) {
        o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [[s, e]]);
        return;
      }
      this.errorHandler.leaveBreadcrumb("New consent invocation"), M(function () {
        o.consents.preConsent.value = _objectSpread(_objectSpread({}, o.consents.preConsent.value), {}, {
          enabled: !1
        }), o.consents.postConsent.value = Na(e);
        var _Zn2 = Zn(o.consents.postConsent.value.consentManagement, _this28.logger),
          c = _Zn2.initialized,
          d = _Zn2.consentsData;
        o.consents.initialized.value = c || o.consents.initialized.value, o.consents.data.value = d;
      }), o.consents.enabled.value && !o.consents.initialized.value && ((r = this.pluginsManager) == null || r.invokeSingle("consentManager.updateConsentsInfo", o, this.storeManager, this.logger)), (i = this.storeManager) == null || i.initializeStorageState(), (a = this.userSessionManager) == null || a.syncStorageDataToState(), (l = this.eventManager) == null || l.resume(), this.loadDestinations(), this.sendTrackingEvents(n);
    }
  }, {
    key: "sendTrackingEvents",
    value: function sendTrackingEvents(e) {
      if (o.consents.postConsent.value.trackConsent) {
        var n = Et(dr);
        e ? o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [["track", n]]) : this.track(n);
      }
      if (o.consents.postConsent.value.sendPageEvent) {
        var _n2 = Ue();
        e ? o.eventBuffer.toBeProcessedArray.value = [].concat(_toConsumableArray(o.eventBuffer.toBeProcessedArray.value), [["page", _n2]]) : this.page(_n2);
      }
    }
  }, {
    key: "setAuthToken",
    value: function setAuthToken(e) {
      var n;
      (n = this.userSessionManager) == null || n.setAuthToken(e);
    }
    // End consumer exposed methods
  }]);
  return un;
}();
var he = /*#__PURE__*/function () {
  // Singleton with constructor bind methods
  function he() {
    _classCallCheck(this, he);
    _(this, "analyticsInstances", {});
    _(this, "defaultAnalyticsKey", "");
    _(this, "logger", Q);
    if (he.globalSingleton) return he.globalSingleton;
    Qe.attachErrorListeners(), this.setDefaultInstanceKey = this.setDefaultInstanceKey.bind(this), this.getAnalyticsInstance = this.getAnalyticsInstance.bind(this), this.load = this.load.bind(this), this.ready = this.ready.bind(this), this.triggerBufferedLoadEvent = this.triggerBufferedLoadEvent.bind(this), this.page = this.page.bind(this), this.track = this.track.bind(this), this.identify = this.identify.bind(this), this.alias = this.alias.bind(this), this.group = this.group.bind(this), this.reset = this.reset.bind(this), this.getAnonymousId = this.getAnonymousId.bind(this), this.setAnonymousId = this.setAnonymousId.bind(this), this.getUserId = this.getUserId.bind(this), this.getUserTraits = this.getUserTraits.bind(this), this.getGroupId = this.getGroupId.bind(this), this.getGroupTraits = this.getGroupTraits.bind(this), this.startSession = this.startSession.bind(this), this.endSession = this.endSession.bind(this), this.getSessionId = this.getSessionId.bind(this), this.setAuthToken = this.setAuthToken.bind(this), this.consent = this.consent.bind(this), he.globalSingleton = this, this.triggerBufferedLoadEvent(), globalThis.rudderanalytics = this;
  }
  /**
  * Set instance to use if no specific writeKey is provided in methods
  * automatically for the first created instance
  * TODO: to support multiple analytics instances in the near future
  */
  _createClass(he, [{
    key: "setDefaultInstanceKey",
    value: function setDefaultInstanceKey(e) {
      e && (this.defaultAnalyticsKey = e);
    }
    /**
    * Retrieve an existing analytics instance
    */
  }, {
    key: "getAnalyticsInstance",
    value: function getAnalyticsInstance(e) {
      var n = e !== null && e !== void 0 ? e : this.defaultAnalyticsKey;
      return !!this.analyticsInstances[n] || (this.analyticsInstances[n] = new un()), this.analyticsInstances[n];
    }
    /**
    * Create new analytics instance and trigger application lifecycle start
    */
  }, {
    key: "load",
    value: function load(e, n, s) {
      if (!k(e)) {
        this.logger.error(Ni(Lt, e));
        return;
      }
      this.analyticsInstances[e] || (this.setDefaultInstanceKey(e), this.analyticsInstances[e] = new un(), this.getAnalyticsInstance(e).load(e, n, s));
    }
    /**
    * Trigger load event in buffer queue if exists and stores the
    * remaining preloaded events array in global object
    */
  }, {
    key: "triggerBufferedLoadEvent",
    value: function triggerBufferedLoadEvent() {
      var e = Array.isArray(globalThis.rudderanalytics) ? globalThis.rudderanalytics : [];
      Ir(e);
      var n = _r(e);
      Fe(st, I(e)), n.length > 0 && (n.shift(), this.load.apply(null, n));
    }
    /**
    * Get ready callback arguments and forward to ready call
    */
  }, {
    key: "ready",
    value: function ready(e) {
      this.getAnalyticsInstance().ready(e);
    }
    /**
    * Process page arguments and forward to page call
    */
  }, {
    key: "page",
    value: function page(e, n, s, r, i) {
      this.getAnalyticsInstance().page(Ue(e, n, s, r, i));
    }
    /**
    * Process track arguments and forward to page call
    */
  }, {
    key: "track",
    value: function track(e, n, s, r) {
      this.getAnalyticsInstance().track(Et(e, n, s, r));
    }
    /**
    * Process identify arguments and forward to page call
    */
  }, {
    key: "identify",
    value: function identify(e, n, s, r) {
      this.getAnalyticsInstance().identify(Sn(e, n, s, r));
    }
    /**
    * Process alias arguments and forward to page call
    */
  }, {
    key: "alias",
    value: function alias(e, n, s, r) {
      this.getAnalyticsInstance().alias(_n(e, n, s, r));
    }
    /**
    * Process group arguments and forward to page call
    */
  }, {
    key: "group",
    value: function group(e, n, s, r) {
      if (arguments.length === 0) {
        this.logger.error(wi(Lt));
        return;
      }
      this.getAnalyticsInstance().group(In(e, n, s, r));
    }
  }, {
    key: "reset",
    value: function reset(e) {
      this.getAnalyticsInstance().reset(e);
    }
  }, {
    key: "getAnonymousId",
    value: function getAnonymousId(e) {
      return this.getAnalyticsInstance().getAnonymousId(e);
    }
  }, {
    key: "setAnonymousId",
    value: function setAnonymousId(e, n) {
      this.getAnalyticsInstance().setAnonymousId(e, n);
    }
  }, {
    key: "getUserId",
    value: function getUserId() {
      return this.getAnalyticsInstance().getUserId();
    }
  }, {
    key: "getUserTraits",
    value: function getUserTraits() {
      return this.getAnalyticsInstance().getUserTraits();
    }
  }, {
    key: "getGroupId",
    value: function getGroupId() {
      return this.getAnalyticsInstance().getGroupId();
    }
  }, {
    key: "getGroupTraits",
    value: function getGroupTraits() {
      return this.getAnalyticsInstance().getGroupTraits();
    }
  }, {
    key: "startSession",
    value: function startSession(e) {
      return this.getAnalyticsInstance().startSession(e);
    }
  }, {
    key: "endSession",
    value: function endSession() {
      return this.getAnalyticsInstance().endSession();
    }
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      return this.getAnalyticsInstance().getSessionId();
    }
  }, {
    key: "setAuthToken",
    value: function setAuthToken(e) {
      return this.getAnalyticsInstance().setAuthToken(e);
    }
  }, {
    key: "consent",
    value: function consent(e) {
      return this.getAnalyticsInstance().consent(e);
    }
  }]);
  return he;
}();
_(he, "globalSingleton", null);
var ft = he;
var ce = function ce(_ref20) {
    var t = _ref20.dataPlaneUrl,
      e = _ref20.writeKey,
      n = _ref20.serviceName,
      s = _ref20.loadOptions;
    var r = new ft(),
      i = {
        eventClient: {
          name: "tracker-js",
          version: "4.5.0"
        },
        service: {
          name: n
        }
      };
    return r.load(e, t, s), {
      trackFromLegacy: function trackFromLegacy(a, l) {
        var p, m;
        var c = {
            tracking_id: l.trackingId,
            event_name: a,
            legacy_event: JSON.stringify(l),
            category: ((p = l == null ? void 0 : l.properties) == null ? void 0 : p.category) || null,
            sub_category: ((m = l == null ? void 0 : l.properties) == null ? void 0 : m.sub_category) || null
          },
          d = {
            context: i
          };
        return r.track("ungoverned", c, d);
      },
      trackPage: function trackPage(a, l, c, d) {
        var p = _objectSpread({
          context: i
        }, d);
        return r.page(a, l, c, p);
      },
      trackIdentify: function trackIdentify(a, l, c, d) {
        var p = _objectSpread({
          context: i
        }, c);
        return r.identify(a, l, p, d);
      },
      track: function track(a, l, c, d) {
        var p = _objectSpread({
          context: i
        }, c);
        return r.track(a, l, p, d);
      }
    };
  },
  yl = function yl(t) {
    var _ref21 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      e = _ref21.apiUrl,
      n = _ref21.trackingId,
      _ref21$transformReque = _ref21.transformRequest,
      s = _ref21$transformReque === void 0 ? bs : _ref21$transformReque,
      _ref21$ssr = _ref21.ssr,
      r = _ref21$ssr === void 0 ? !1 : _ref21$ssr,
      _ref21$validateAllowl = _ref21.validateAllowlist,
      i = _ref21$validateAllowl === void 0 ? !0 : _ref21$validateAllowl,
      a = _ref21.providedEnvironment,
      l = _ref21.rudderstackDataPlane,
      c = _ref21.rudderstackDataPlaneUrl,
      _ref21$rudderstackFFE = _ref21.rudderstackFFEnabled,
      d = _ref21$rudderstackFFE === void 0 ? !1 : _ref21$rudderstackFFE,
      p = _ref21.rudderstackWriteKey,
      m = _ref21.rudderstackConfig;
    $s(t, {
      validateAllowlist: i
    });
    var N = e || ms(a);
    var g = n || (r ? "" : Pt.get());
    return {
      setTrackingId: function setTrackingId(h) {
        g = h;
      },
      track: function track(h, E) {
        var T;
        Us({
          eventDictionary: t,
          eventName: h,
          properties: E
        });
        var v = {
            apiUrl: N,
            eventName: h,
            namespace: t.namespace,
            properties: _objectSpread(_objectSpread({}, E), {}, {
              url: (T = window == null ? void 0 : window.location) == null ? void 0 : T.href,
              unique_record_id: vs()
            }),
            trackingId: g
          },
          b = c || l;
        return g ? (d && b && p && ce({
          dataPlaneUrl: b,
          writeKey: p,
          serviceName: t.namespace,
          loadOptions: m
        }).trackFromLegacy(h, v), Nt(s(v), {
          ssr: r
        })) : Pt.set(a).then(function (K) {
          return v.trackingId = K, g = K, d && b && p && ce({
            dataPlaneUrl: b,
            writeKey: p,
            serviceName: t.namespace,
            loadOptions: m
          }).trackFromLegacy(h, v), Nt(s(v), {
            ssr: r
          });
        });
      },
      trackPageView: function trackPageView(h, E, v, b) {
        var T = c || l;
        return d && T && p ? (ce({
          dataPlaneUrl: T,
          writeKey: p,
          serviceName: t.namespace,
          loadOptions: m
        }).trackPage(h, E, v, b), !0) : !1;
      },
      trackIdentify: function trackIdentify(h, E, v, b) {
        var T = c || l;
        return d && T && p ? (ce({
          dataPlaneUrl: T,
          writeKey: p,
          serviceName: t.namespace,
          loadOptions: m
        }).trackIdentify(h, E, v, b), !0) : !1;
      },
      rudderTrack: function rudderTrack(h, E, v, b) {
        var T = c || l;
        return d && T && p ? (ce({
          dataPlaneUrl: T,
          writeKey: p,
          serviceName: t.namespace,
          loadOptions: m
        }).track(h, E, v, b), !0) : !1;
      },
      rudderTracker: function rudderTracker() {
        var h = c || l;
        return d && h && p ? ce({
          dataPlaneUrl: h,
          writeKey: p,
          serviceName: t.namespace,
          loadOptions: m
        }) : null;
      }
    };
  },
  Fl = yl,
  Sl = function Sl(t) {
    if (t === null) return {};
    var e = "chat";
    return t.includes("contact-us/") ? e = "send message" : t.includes("mailto") ? e = "email" : t.includes("tel") ? e = "phone" : t.includes("fax") && (e = "fax"), {
      event: "contact_us",
      contact_type: e
    };
  },
  _l = function _l(t) {
    var e;
    (e = window.dataLayer) == null || e.push(Sl(t.target.href));
  },
  Il = _l,
  bl = function bl(t) {
    t.addEventListener("click", Il);
  },
  Tl = function Tl() {
    var t = document.querySelectorAll(".dropdown-menu .flex-wrap");
    t.length && t.forEach(function (e) {
      e.innerHTML.indexOf("Send us a message") !== -1 && e.childNodes.forEach(function (n) {
        n.childNodes.forEach(function (s) {
          s.nodeName === "A" && bl(s);
        });
      });
    });
  },
  rs = Tl;
var bt = /* @__PURE__ */function (t) {
  return t.FORM_START = "form_start", t.FORM_SUBMIT = "form_submit", t;
}(bt || {});
var is = "hubspot",
  Rl = /^hsForm/,
  Al = function Al(t) {
    return !!t.id.match(Rl);
  },
  Tt = function Tt(t) {
    return t instanceof HTMLFormElement && Al(t);
  },
  dn = "true",
  Ol = '.hs-input:not([type="hidden"])',
  Pl = function Pl(t) {
    return !!t && (t instanceof HTMLInputElement || t instanceof HTMLSelectElement || t instanceof HTMLTextAreaElement);
  },
  Nl = function Nl(t) {
    return Pl(t) ? t.form : null;
  },
  wl = function wl(_ref22) {
    var t = _ref22.target;
    var e = Nl(t);
    if (!e) return;
    var _e$dataset = e.dataset,
      n = _e$dataset.formId,
      s = _e$dataset.started;
    s !== dn && (window.dataLayer.push({
      event: bt.FORM_START,
      form_id: n,
      form_host: is
    }), e.dataset.started = dn);
  },
  Dl = function Dl(t) {
    if (!Tt(t)) return;
    t.querySelectorAll(Ol).forEach(function (n) {
      n.addEventListener("input", wl);
    });
  },
  kl = Dl,
  Ll = function Ll(t) {
    return t.querySelector('input[type="submit"], button[type="submit"], button');
  },
  Cl = function Cl(_ref23) {
    var t = _ref23.target,
      e = _ref23.submitter;
    if (!Tt(t)) return;
    var n = t,
      s = n.dataset.formId,
      r = e || Ll(n),
      i = r == null ? void 0 : r.value;
    window.dataLayer.push({
      event: bt.FORM_SUBMIT,
      form_id: s !== null && s !== void 0 ? s : "",
      form_host: is,
      click_text: i !== null && i !== void 0 ? i : ""
    });
  },
  Ul = function Ul(t) {
    Tt(t) && t.addEventListener("submit", Cl);
  },
  Ml = Ul,
  os = {
    registerContactUsClick: rs,
    registerHubspotFormStart: kl,
    registerHubspotFormSubmit: Ml
  },
  $l = function $l() {
    window && (window.dataLayer || (window.dataLayer = []), window.gtmEventTracker || (window.gtmEventTracker = os), rs());
  },
  Bl = _objectSpread({
    initialize: $l
  }, os),
  Hl = Bl;
export { X as Environment, Fl as createTracker, Hl as gtmEventTracker };